import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { ErrorTextComp } from '../../../../inputs/fields.component'
import { ThemeProvider, Checkbox, Button, Dropdown } from '@workboard/wobo-ui';
import styled from 'styled-components';
import GoalServices from '../../../../../services/goal.services'
import PermissionComp from '../permission.component'
import Customokr from "../../../../custom_fields/customobj/Customokr";
import {
  reactLoader,
  removeReactLoader,
  WbEventHandlerMixins,
  getQuarterStartYear,
} from '../../../../../utils/common.js'
import {
  resolveMitDateSegments,
  createDefaultMitDateSegment,
  createInitialMitDateSegments,
  initialMitIntervalMode,
  isQuarterlyAggregationMitType,
  needsDefaultMitChildren,
} from './mitDateSegments'
import {
  createUtcDateSegmentsFallback,
  formatUtcSegmentForSave,
  isInvalidCustomMitEndDate,
  isInvalidCustomMitStartDate,
  parseUtcGoalDate,
  parseUtcSegmentDate,
} from './mitDateUtils'
import {
  MIT_INTERVAL_TYPE,
  MIT_TYPE,
  getMitChildCounting,
} from './mitConstants'
import { ButtonsComp } from '../../../../inputs/buttons.component'
import DataStreamComp from '../datastreams.component'
import DeleteCommonModal from '../../../../deleteCommonModal.component'
import KrAlignDependance from '../krAlignDependence'
import MetricOwnerCommonModal from '../metric-owner.component'
import OverallTarget from './overallTarget.component'
import MitIntervalTargets from './mitIntervalTargets.component'
import QuarterlyIntervals from './quarterlyIntervals.component'
import HelpTextComp from '../../../../helper/helptext.component'
import {
  IntervalTexts,
  getIntervalOptions,
  getWeekDaysOptions,
  isWeeklyInterval,
  stripMitChildUnitOfMeasure,
} from '../../../../../utils/metric'
import AddKrTag from '../../../../../krTags/components/addkrTag.component'
import RetainUpdateModal  from '../../../../retainUpdateModal.component'
import axios from 'axios';
import _ from 'lodash';
import KrRelationshipWrapper from '../krRelationshipWrapper';
import { krdetailConstants } from '../../../../../constants/krdetails.constants';
import { AddFinancialTargetsButton } from '../../AddFinancialTargetsButton';


const MIT_DS_METRICS = ['1', '2','8','9', 1, 2, 8, 9]
const MIT_PROGRESS_TYPE = ['1', '2', 1, 2]

let intervalTypeCheck
let sameSource

const StyledCheckbox = styled(Checkbox)`
  .MuiButtonBase-root {
    width: 24px;
    height: 24px;
    margin-left: -5px;
  }
  svg {
    width: 24px;
    height: 24px;
  }
`;

const StyledDropdown = styled(Dropdown)`
  min-width: 113px !important;
  width: unset !important;
  height: 39px !important
  > svg {
    margin-right: 10px !important;
  }
  .MuiSelect-root {
    background-color: #f2f2f2 !important;
    border: 1px solid rgba(0,0,0,0.06);
    height: 38px;
  }
  #cal-overall-dropdown, #cal-overall-child-dropdown{
    min-width: 226px;
  }
  #select-day-dropdown{
    min-width: 120px;
  }
  #select-interval-dropdown{
    min-width: 113px;
  }
`;

/**
 * Fallback when resolveMitDateSegments returns empty (e.g. start equals end, or invalid range).
 * Creates one segment: start = KR start, end = start + 1 month, capped at KR target.
 */
const createDateSegmentsFallback = (krStartDate, krTargetDate) => [
  createUtcDateSegmentsFallback(krStartDate, krTargetDate),
]

const getDateSegmentsWithFallback = (
  segments,
  krStartDate,
  krTargetDate
) => {
  if (!Array.isArray(segments) || segments.length === 0) {
    return createDateSegmentsFallback(krStartDate, krTargetDate)
  }
  return segments
}

class MitPeople extends Component {
  constructor(props) {
    super(props)
    let isStretchEnabled = this.props.addOkrData.isStretchEnabled ??  this.props.goalDetails.isStretchEnabled ?? false
    let committedKRFlag = isStretchEnabled && this.props.item && parseInt(this.props.item.committed_target) ? parseInt(this.props.item.committed_target) : 0
    const { t }  = this.props
    const isKrCoOwnerEnabled = window.wbConfig.isKrCoOwnerEnabled ?? false;
    const parentProgressType =
      this.props.item &&
      this.props.item.id &&
      this.props.item.progress_type &&
      //this.props.lastType != 'person'
      WbEventHandlerMixins.getKrType(
        this.props.item.source,
        this.props.item.type
      ) == this.props.krType
        ? this.props.item.progress_type
        : 2

    const mitProgressType =
      this.props.item && this.props.item.child_progress_type
        ? this.props.item.child_progress_type
        : 2
    intervalTypeCheck =
      !(!Array.isArray(this.props.item) && this.props.item.id) &&
      moment(this.props.goalDetails.start_date)
        .endOf('quarter')
        .isBefore(moment(this.props.goalDetails.target_date))
        ? MIT_INTERVAL_TYPE.QUARTER
        : !(!Array.isArray(this.props.item) && this.props.item.id) &&
          moment(this.props.goalDetails.start_date)
            .endOf('month')
            .isBefore(moment(this.props.goalDetails.target_date))
        ? MIT_INTERVAL_TYPE.MONTH
        : MIT_INTERVAL_TYPE.CUSTOM
        sameSource = (this.props.item.child_krs && this.props.item.child_krs.length > 0) ? ((this.props.item.child_krs.map(a => a.source).includes("1") || this.props.item.child_krs.map(a => a.source).includes("10")) ? true : false ) : true;
    this.state = {
      MeasureEn: false,
      name: this.props.item && this.props.item.name ? this.props.item.name : '',
      mitType: this.props.mitType,
      mitTypeBeforeEdit: this.props.mitType,
      mitTypeChangeAlert: false,
      initial_data:
        this.props.item && this.props.item.initial_data
          ? this.props.item.initial_data
          : this.props.basicInlineData &&
            this.props.basicInlineData.initial_data
          ? this.props.basicInlineData.initial_data
          : 0,
      target:
      (!isStretchEnabled && this.props.item && this.props.item.target) ||
      (isStretchEnabled && this.props.item && this.props.item.stretch_target !== null) ||
      (isStretchEnabled && committedKRFlag && this.props.item && this.props.item.stretch_target == null)
          ? this.props.item.target
          : !isStretchEnabled && this.props.basicInlineData && this.props.basicInlineData.target
          ? this.props.basicInlineData.target
          : '',
      stretch:  this.props.item && this.props.item.stretch_target !== null
          ? this.props.item.stretch_target
          : isStretchEnabled && this.props.item && this.props.item.target && !committedKRFlag
          ? this.props.item.target : '',
      measure: 1,
      interval:
        this.props.item && this.props.item.interval
          ? this.props.item.interval
          : this.props.basicInlineData && this.props.basicInlineData.interval
          ? this.props.basicInlineData.interval
          : '',
      data_provider: {
        id: this.props.owner.id,
        name: this.props.owner.name,
        avatar: this.props.owner.avatar,
      },
      measureText: t('Count as number'),
      intervalText: t('Weekly'),
      ErrorDis: '',
      intervalEn: '',
      krOwnerEn: false,
      fields: {},
      errors: {},
      porgressEn: false,
      childPorgressEn: false,
      TargetHelpPopUp: false,
      dayEn: false,
      progressHelpPopUp: false,
      permissionHelpPopUp: false,
      intervalDayEn: false,
      upper_limit:
        this.props.item && this.props.item.upper_limit
          ? this.props.item.upper_limit
          : '',
      lower_limit:
        this.props.item && this.props.item.upper_limit
          ? this.props.item.lower_limit
          : '',
      range: false,
      dsMetric:
        this.props.item &&
        this.props.item.counting &&
        MIT_DS_METRICS.includes(this.props.item.counting)
          ? this.props.item.counting
          : 1,
      metricDD: false,
      progType: parentProgressType,
      childProgType: mitProgressType,
      measureType:
        this.props.item && this.props.item.metric
          ? this.props.item.metric == 4 || this.props.item.metric == 0
            ? 1
            : this.props.item.metric
          : this.props.basicInlineData && this.props.basicInlineData.metric
          ? this.props.basicInlineData.metric
          : 1,
      intervalType:
        this.props.item && this.props.item.interval
          ? this.props.item.interval != 0
            ? this.props.item.interval
            : 2
          : this.props.basicInlineData && this.props.basicInlineData.interval
          ? this.props.basicInlineData.interval != 0
            ? this.props.basicInlineData.interval
            : 2
          : 2,
      dayType:
        this.props.item && this.props.item.weekly_update_day
          ? this.props.item.weekly_update_day
          : 5,
      teamPermissionSelected:
        this.props.item && this.props.item.permission_teams
          ? this.props.item.permission_teams
          : this.props.goalDetails.type == 1 &&
            this.props.goalDetails.default_permission_teams &&
            Object.keys(this.props.goalDetails.default_permission_teams)
              .length > 0
          ? this.props.goalDetails.default_permission_teams
          : [],
      bizPermissionSelected:
        this.props.item && this.props.item.permission_biz
          ? this.props.item.permission_biz
          : [],
      permission: [],
      permissionstate:
        this.props.item && this.props.item.permission
          ? this.props.item.permission.split(',').map(Number)
          : this.props.goalDetails.type == 1
          ? this.props.goalDetails.default_permission &&
            Object.keys(this.props.goalDetails.default_permission).length > 0
            ? this.props.goalDetails.default_permission.split(',').map(Number)
            : [8]
          : [10],
      applyObjKr:
        this.props.goalDetails && this.props.goalDetails.all_metrics == 1
          ? true
          : false,
      source:
        this.props.item && this.props.item.source ? this.props.item.source : 1,
      Exclude:
        this.props.item && this.props.item.progress_consider == 0
          ? true
          : false,
      krId: this.props.item && this.props.item.id ? this.props.item.id : '',
      subPermissonEn: false,
      startValueErr: t('Add Value'),
      targetValueErr: t('Add Value'),
      stretchValueErr: t('Add Value'),
      lowerLimitErr: t('Add Value'),
      upperLimitErr: t('Add Value'),
      _isTeamMounted: false,
      krPermissionText:
        this.props.goalDetails &&
        this.props.goalDetails.permission &&
        this.props.goalDetails.permission.length > 0
          ? this.props.goalDetails &&
            this.props.goalDetails.permission &&
            this.props.goalDetails.permission.length > 1
            ? t('Custom view permissions')
            : t('Organization can view')
          : this.props.goalDetails.type == 1
          ? t('Only team can view')
          : t('Only owner can view'),
      _isOwnerMounted: false,
      hide: false,
      ownerSearchVal: '',
      mitIntervals: (WbEventHandlerMixins.getKrType(this.props.item.source, this.props.item.type) === 'multipleIntervalTargets'
        && this.props.item.child_krs)
        ? this.props.item.child_krs
        : [1], //Initialize with single index array
      dateSegments:
        this.props.mitType === MIT_TYPE.SUPPORTING_QUARTER_KR
          ? createDateSegmentsFallback(
              this.props.goalDetails.start_date,
              this.props.goalDetails.target_date
            )
          : createInitialMitDateSegments(
              this.props.item,
              this.props.goalDetails,
              this.props.mitType,
              this.props.addOkrData.org_quarter_dates,
              this.props.goalDetails.filterOption,
              this.props.goalDetails.orgReportingPeriods
            ),
      mitChildError: false,
      mitChildErrorMsg: '',
      segmentErrors: [],
      isMitEdit: false,
      disableProgType: !!(
        this.props.item &&
        this.props.item.counting &&
        this.props.item.counting == 2
      ),
      quarter_start: this.props.addOkrData.org_quarter_dates,
      confirmPopup: false,
      mitTypeChange: false,
      krAlingSelected:
        this.props.item &&
        this.props.item.kr_aligns !== undefined &&
        this.props.item.kr_aligns.length > 0
          ? this.props.item.kr_aligns
          : [],
      krDependenciesSelected:
        this.props.item &&
        this.props.item.kr_dependent !== undefined &&
        this.props.item.kr_dependent.length > 0
          ? this.props.item.kr_dependent
          : [],
      committedKRFlag:
          !isStretchEnabled &&  this.props.item && this.props.item.committed_target != null
          ? this.props.item.committed_target
          : 0,
      firstInterval: initialMitIntervalMode(this.props.mitType, this.props.goalDetails),
      tags: [],
      selectedType: '',
      titleRetain: 'Change update frequency',
      contentRetain: '',
      sourceType:1,
      intervalConfirmPopup: false,
      // nestedType: "1"
      child_krs: (WbEventHandlerMixins.getKrType(this.props.item.source, this.props.item.type) === 'multipleIntervalTargets'
        && this.props.item.hasOwnProperty('child_krs'))
        ? _.cloneDeep(this.props.item.child_krs)
        : [],
      nplTags:this.props.nplTags ? this.props.nplTags : [],
      selectednlplTags:this.props.selectednlplTags ? this.props.selectednlplTags : [],
      selectednlplTagsName:this.props.selectednlplTagsName ? this.props.selectednlplTagsName : [],
      tagsList:this.props.tagsList ? this.props.tagsList:[],
      customFiledRequired:false,
      isCustomSave:[],
      isRequirdCustomOkr:[],
      customInputData:[],
      isStretchEnabled: isStretchEnabled,
      coOwners: isKrCoOwnerEnabled ? (this.props.item.coOwners && this.props.item.coOwners.length > 0 ? this.props.item.coOwners : (this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [])) : [],
      checkRolFlag: this.props.item?.is_real_owner_rol != undefined ? true : false,
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleErrorChange = this.handleErrorChange.bind(this)
    this.setRightPaneValue = this.setRightPaneValue.bind(this)
    this.GoalServices = new GoalServices()
    this.clickEvent = this.clickEvent.bind(this)
    this.handleExcludeChange = this.handleExcludeChange.bind(this)
    this.toggelePermission = this.toggelePermission.bind(this)
    this.toggeleSubPermission = this.toggeleSubPermission.bind(this)
    this.targetClick = this.targetClick.bind(this)
    this.permissionData = this.permissionData.bind(this)
    this.teamPermissionData = this.teamPermissionData.bind(this)

    this.exitDeleteModal = this.exitDeleteModal.bind(this)
    this.saveItems = this.saveItems.bind(this)
    this.saveKr = this.saveKr.bind(this)
    this.saveAlignArr = this.saveAlignArr.bind(this)
    this.saveDependentArr = this.saveDependentArr.bind(this)
    this.handleEndDateChange = this.handleEndDateChange.bind(this)
    this.setErrors = this.setErrors.bind(this)
    this.setDateSegments = this.setDateSegments.bind(this)
    this.updateSegmentsError = this.updateSegmentsError.bind(this)
    this.changeRadio = this.changeRadio.bind(this)
    this.updateTags = this.updateTags.bind(this);
    this.isRequiredCustomOkrFiled = this.isRequiredCustomOkrFiled.bind(this);
    this.isSaveCustom =this.isSaveCustom.bind(this)
    this.renderError = this.renderError.bind(this);
    this.syncKrsWithKpiData = this.syncKrsWithKpiData.bind(this);
    this.handleProgressTypeChange = this.handleProgressTypeChange.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    // data segments code needs to be cleanedd up, negative condition code needs to be removed for first two conditions
    if (nextProps.mitType !== prevState.mitType) {
      if (isQuarterlyAggregationMitType(nextProps.mitType)) {
        const _progType = (nextProps.mitType == MIT_TYPE.ADD_UP) ? 2
        : (nextProps.mitType == MIT_TYPE.AVG_RESULTS) ? 3 : 1;
        // MR-8337: Decrease-to is not valid with "Add up results"
        const nextDsMetric =
          nextProps.mitType == MIT_TYPE.ADD_UP && prevState.dsMetric == krdetailConstants.METRIC_COUNTING_DOWN
            ? krdetailConstants.METRIC_COUNTING_UP
            : prevState.dsMetric;
        const nextChildKrs =
          nextDsMetric !== prevState.dsMetric && Array.isArray(prevState.child_krs)
            ? prevState.child_krs.map((childKr) => ({
                ...childKr,
                counting: nextDsMetric,
              }))
            : prevState.child_krs;
        return {
          mitType: nextProps.mitType,
          progType: _progType,
          childProgType: _progType,
          dsMetric: nextDsMetric,
          child_krs: nextChildKrs,
          disableProgType: nextDsMetric == krdetailConstants.METRIC_COUNTING_DOWN,
          showProgType: false,
          childPorgressEn: false,
          dateSegments: needsDefaultMitChildren(nextProps.item)
            ? createInitialMitDateSegments(
                nextProps.item,
                nextProps.goalDetails,
                nextProps.mitType,
                nextProps.addOkrData.org_quarter_dates,
                nextProps.goalDetails.filterOption,
                nextProps.goalDetails.orgReportingPeriods
              )
            : prevState.mitType == MIT_TYPE.CUSTOM ||
              prevState.mitType == '' ||
              prevState.mitType == MIT_TYPE.SUPPORTING_QUARTER_KR
            ? getDateSegmentsWithFallback(
                resolveMitDateSegments(
                  nextProps.item,
                  nextProps.goalDetails,
                  intervalTypeCheck,
                  nextProps.goalDetails.start_date,
                  nextProps.goalDetails.target_date,
                  nextProps.addOkrData.org_quarter_dates,
                  nextProps.mitType,
                  nextProps.goalDetails.filterOption,
                  nextProps.goalDetails.orgReportingPeriods
                ),
                nextProps.goalDetails.start_date,
                nextProps.goalDetails.target_date
              )
            : prevState.dateSegments,
          firstInterval: initialMitIntervalMode(nextProps.mitType, nextProps.goalDetails),
        }
      } else if (nextProps.mitType == MIT_TYPE.CUSTOM) {
        return {
          mitType: MIT_TYPE.CUSTOM,
          progType: nextProps.kpiType == 'ds' ? 1 : 2,
          childProgType: nextProps.kpiType == 'ds' ? 1 : 2,
          showProgType: false,
          childPorgressEn: false,
          dateSegments: needsDefaultMitChildren(nextProps.item)
            ? createDefaultMitDateSegment(nextProps.goalDetails)
            : intervalTypeCheck == MIT_INTERVAL_TYPE.MONTH || intervalTypeCheck == MIT_INTERVAL_TYPE.QUARTER
            ? getDateSegmentsWithFallback(
                resolveMitDateSegments(
                  nextProps.item,
                  nextProps.goalDetails,
                  intervalTypeCheck,
                  nextProps.goalDetails.start_date,
                  moment(nextProps.goalDetails.start_date)
                    .endOf('month')
                    .format('MMM DD, YYYY'),
                  nextProps.addOkrData.org_quarter_dates,
                  nextProps.mitType,
                  nextProps.goalDetails.filterOption,
                  nextProps.goalDetails.orgReportingPeriods
                ),
                nextProps.goalDetails.start_date,
                nextProps.goalDetails.target_date
              )
            : createDefaultMitDateSegment(nextProps.goalDetails),
          firstInterval: MIT_INTERVAL_TYPE.CUSTOM,
        }
      } else {
        return {
          mitType: MIT_TYPE.SUPPORTING_QUARTER_KR,
          dateSegments: createDateSegmentsFallback(
            nextProps.goalDetails.start_date,
            nextProps.goalDetails.target_date
          ),
          progType: null,
          childProgType: null,
          showProgType: false,
          childPorgressEn: false,
        }
      }
    } else return null
  }

  /**
   * Function call to set values if type is edit
   * @private
   */
  _isEdit = () => {
    let { dateSegments } = this.state
    let { item } = this.props
    // Only hydrate from saved MIT children when the metric is still an MIT parent.
    // After MIT→basic, child_krs can linger in wizard state even though DB children were deleted.
    if (WbEventHandlerMixins.getKrType(item?.source, item?.type) === 'multipleIntervalTargets'
      && item['child_krs'] && item['child_krs'].length) {
      // 16420. When fiscal year is custom get Q4 end_date
      let year = moment(
        item['child_krs'][item['child_krs'].length - 1]['end_date'],
        'MM/DD/YYYY'
      ).year()
      const monthNumber = moment(
        item['child_krs'][0]['start_date']
      ).format('M');
      let goalStartDate = moment(this.props.goalDetails.start_date).format('MM/DD/YYYY');
      let goalTargetDate = moment(this.props.goalDetails.target_date).format('MM/DD/YYYY');
      dateSegments = []
      let mYear = getQuarterStartYear(goalStartDate, goalTargetDate, this.props.goalDetails.filterOption);
      let isOrgPeriodMatch = false;
      let orgReportingPeriods = this.props.goalDetails.orgReportingPeriods
      if (Array.isArray(orgReportingPeriods) && orgReportingPeriods.length) {
        const startYear = moment(goalStartDate).format('YYYY');
        isOrgPeriodMatch = moment(goalStartDate).isSame(orgReportingPeriods[0].start + '/' + startYear)
      }
      for (let i = 0; i < item['child_krs'].length; i++) {
        const quarterEndYear =  moment(item['child_krs'][i]['start_date'],'MM/DD/YYYY').year();
        if ( quarterEndYear <= year && i > 3 && (i % 4) == 0) {
          mYear++;
        } else if (isOrgPeriodMatch &&  mYear < year) {
          mYear = year;
        }
        dateSegments.push({
          startDate: moment(item['child_krs'][i]['start_date']).format(
            'MMM DD, YYYY'
          ),
          endDate: moment(item['child_krs'][i]['end_date']).format(
            'MMM DD, YYYY'
          ),
          intervalName: item['child_krs'][i]['name'],
          quarterName: item['child_krs'][i]['quarterName'],
          targetValue: item['child_krs'][i]['target'],
          status: item['child_krs'][i]['status'] ? item['child_krs'][i]['status'] : 1,
          krId: item['child_krs'][i]['id'],
          year: mYear,
          owner: item['child_krs'][i]['owner'] ? item['child_krs'][i]['owner'] : item['owner']
        })
      }
    }

    // This is the wb worker owner ID. If it is wb worker, we need to reset the owner to be goal owner.
    if (this.props.item.owner_email == 'wb-worker@workboard.com') {
      let data = {
        userText: this.props.goalDetails.owner_fullname,
        userId: this.props.goalDetails.owner_id,
        userPic: this.props.goalDetails.owner_pic,
      }

      this.updateDataProvider(data)
    } else {
      this.setState({
        dateSegments: dateSegments,
        isMitEdit: true,
      })
    }
  }

  getProgressType = (mitType) => {
    let progressType = 2;
    if(mitType == MIT_TYPE.TRACK_PROGRESSION){
      progressType = 1;
    } else if(mitType == MIT_TYPE.AVG_RESULTS){
      progressType = 3;
    } else {
      progressType = 2;
    }
    return progressType;
  }

  checkExcludedType = (ext_app_id) => {
    const ext_app_ids  = [5, 6];
    if(ext_app_ids.includes(parseInt(ext_app_id))){
      return false;
    }
    return true;
  }
  renderError(field) {
    return (
      <ErrorTextComp key={field} errors={this.state.errors} field={field} />
    );
  }
  deleteProperties (obj){
    if(obj.metricMetric){
      obj.src_metrics = obj.metricMetric.map(item => item.id);
      delete obj.metricMetric;
    }
    if(obj.metricGoal){
      obj.goalSourceId = obj.metricGoal.map(item => item.id);
      delete obj.metricGoal;
    }
    if(obj.metricMirror){
      obj.mirror_kr_id = obj.metricMirror.map(k => k.id).join("");
      delete obj.metricMirror;
    }
    if(obj.metricWs){
      let dependentWsSel = obj.metricWs;
      let dependentWs = [];
      if (Object.keys(dependentWsSel).length > 0) {
        dependentWsSel.map(item => {
          if (item.ws) {
            item.ws.map(item1 => {
              dependentWs.push(item1.id);
            });
          }
        });
      }
      obj.metricWs = dependentWs;

      /*
      format needed to drive UI:
        metric: {
          metricWsColumn: [
            {
              id: 123, // WS id
              ws_name: "WS1",
              col: [
                { id: 456, name: "Col1" }   // WS column id
                { id: 789, name: "Col2" }
                ... more columns ...
              ]
            }
            ... more WS ...
          ]
        ... other props ...
        }

        server save format:
          metric: {
            metricWsColumn: {
              // the array index is the WS id
              123: "456,789"
              ... more WS ...
            }
          }

      */
      // translate the initial load format to the server save format
      const metricWsColumn = [];
      if (obj.metricWs?.length && obj.metricWsColumn?.length) {
        const isInitialLoadDataFormat = obj.metricWsColumn[0]?.hasOwnProperty('col') ?? false;

        if (isInitialLoadDataFormat) {
          obj.metricWsColumn.map(item => {
            // ensure WS is still in our selected list
            if (item.col && obj.metricWs.includes(item.id)) {
              const wsColumnIds = item.col.map(col => col.id).join(",");
              metricWsColumn[item.id] = wsColumnIds;
            }
          });
        }
        obj.metricWsColumn = metricWsColumn;
      }

    }
    return stripMitChildUnitOfMeasure(obj);
  }
  async getUserAccessToken(clientId) {
    const res = await axios.get(`${wbConfig.baseUrl}/client/generateUserAccessToken?client_id=${clientId}`);
    return res?.data;
  }

  updateDataProvider = (data) => {
    this.setState({
      data_provider: {
        id: data.userId,
        name: data.userText,
        avatar: data.userPic,
      },
      checkRolFlag: false
    })
  }
  componentWillUnmount() {
		this.props.metricRef(null)
	}

  componentDidMount() {
    this.props.metricRef(this)
    document.addEventListener('mousedown', this.clickEvent, false)
    $('.goalPopupNew').css('overflow', 'hidden')
    //If edit, call the edit option and populate the values of the kr's
    if (!Array.isArray(this.props.item) && this.props.item.id) {
      this._isEdit()
    }
  }

  handleExcludeChange() {
    this.setState({
      Exclude: !this.state.Exclude,
    })
  }

  toggelePermission() {
    this.setState({
      permissonEn: true,
    })
  }

  toggeleSubPermission() {
    this.setState({
      subPermissonEn: true,
      permissonEn: true,
    })
  }

  targetClick(e, id) {
    this.setState({
      dsMetric: id,
      errors: {},
    })
  }

  permissionData(perData) {
    this.setState({
      permissionstate: perData,
    })
  }

  teamPermissionData(teamPerData) {
    this.setState({
      teamPermissionSelected: teamPerData,
    })
  }

  bizPermissionData = (bizPerData) => {
    this.setState({
      bizPermissionSelected: bizPerData,
    })
  }

  clickEvent(e) {
    if (
      !$('.metricmeasureArea').is(e.target) &&
      $('.metricmeasureArea').has(e.target).length === 0
    ) {
      if (this.state.MeasureEn) {
        this.setState({
          MeasureEn: false,
        })
      }
    }
    if (
      !$('.krTimeRange').is(e.target) &&
      $('.krTimeRange').has(e.target).length === 0
    ) {
      if (this.state.intervalEn) {
        this.setState({
          intervalEn: false,
        })
      }
    }
    if (
      !$('.ownerKrName').is(e.target) &&
      $('.ownerKrName').has(e.target).length === 0 &&
      !$('.myownerAlign ').is(e.target) &&
      $('.myownerAlign').has(e.target).length === 0
    ) {
      if (this.state.krOwnerEn) {
        this.setState({
          krOwnerEn: false,
        })
      }
    }
    if (
      !$('.CalculateOverDropDown').is(e.target) &&
      $('.CalculateOverDropDown').has(e.target).length === 0
    ) {
      if (this.state.porgressEn) {
        this.setState({
          porgressEn: false,
        })
      }
    }
    if (
      !$('.krTimeRange').is(e.target) &&
      $('.krTimeRange').has(e.target).length === 0
    ) {
      if (this.state.intervalEn) {
        this.setState({
          intervalEn: false,
        })
      }
    }
    if (
      !$('.metricTimeRange').is(e.target) &&
      $('.metricTimeRange').has(e.target).length === 0
    ) {
      if (this.state.dayEn) {
        this.setState({
          dayEn: false,
        })
      }
    }
    if (
      !$('.aEPermissionList').is(e.target) &&
      $('.aEPermissionList').has(e.target).length === 0
    ) {
      if (this.state.permissonEn || this.state.subPermissonEn) {
        this.setState({
          permissonEn: false,
          subPermissonEn: false,
        })
      }
    } else {
      //for opening popup scrollto donw.
      setTimeout(() => {
        var $target = $('.krRightPaneContent')
        if ($('.permissionContent').length) {
          $target.animate(
            { scrollTop: $('.krRightPaneContent').scrollTop() + 150 },
            1000
          )
        }
        if ($('.teamPermission').length) {
          $target.animate(
            { scrollTop: $('.krRightPaneContent').scrollTop() + 250 },
            1000
          )
        }
      }, 1)
    }
    if (
      !$('.metricTargetValue').is(e.target) &&
      $('.metricTargetValue').has(e.target).length === 0
    ) {
      if (this.state.metricDD) {
        this.setState({
          metricDD: false,
        })
      }
    }
  }

  handleChange(e) {
    const pattern = /^(\.)?[0-9,-]+(\.\d{0,10})?$/
    let name = e.target.name
    let value = e.target.value
    const state = this.state
    if (value.trim() !== '') {
      state['errors'] = {}
    }
    if (value === '' || pattern.test(value)) {
      state[name] = value
      // this.setState(state);
      this.setState({
        [name]: value,
      })
    }
  }

  handleErrorChange(name, value) {
    const state = this.state
    state[name] = value
    this.setState(state)
  }

  setRightPaneValue() {
    this.props.closeKrRightPane(false, this.state.krId)
    this.setState({ mitTypeChangeAlert: false })
  }

  saveQuarterlyKR = (savedKrData, index) => {
    const {dateSegments, child_krs} = this.state;
    dateSegments[index]['intervalName'] = savedKrData['name'] || dateSegments[index]['intervalName'] || "";
    dateSegments[index]['krId'] = savedKrData['id'];
    dateSegments[index]['targetValue'] = (savedKrData['target'] || (!savedKrData['target'] && savedKrData['stretchTarget'])) ? savedKrData['target'] : "";
    dateSegments[index]['krType'] = savedKrData['krType'];
    dateSegments[index]['source'] = savedKrData['source'];
    dateSegments[index]['owner_pic'] = savedKrData['owner_pic'];
    dateSegments[index]['owner'] = savedKrData['owner'];
    dateSegments[index]['status'] = 1;
    dateSegments[index]['stretchValue'] = (!savedKrData['target'] && savedKrData['stretchTarget'])  ? "" : savedKrData['stretchTarget'];
    if (savedKrData?.retainUpdates) {
      dateSegments[index]['retainUpdates'] = savedKrData['retainUpdates'];
    }
    savedKrData['setStretch'] = (savedKrData['target'] == '' && savedKrData['stretchTarget'] !== '') ? true : false;
    child_krs[index] = stripMitChildUnitOfMeasure({ ...savedKrData });
    child_krs[index]['status'] = 1;
    this.setState({
      dateSegments, child_krs
    });
  }

  /**
   * Save the Person type Kr with child krs
   * @param e
   */
  saveKr(callback = null) {
    let { krType, addEditFlag, lastType, t, quarterTargetType, isAnnualMit } =
      this.props
      const {child_krs} = this.state;
    this.isSaveCustom(this.state.customInputData)
    this.setState({isCustomSave:[]})
    let errors = {}
    let metricName = $('#metric-name-text').val()
    let metricNote = this.props.krNote
    let initial_data = this.state.initial_data
    let target = this.state.target
    let stretch = this.state.stretch
    let targetLowerVal = this.state.lower_limit
    let targetUpperVal = this.state.upper_limit
    let numberWithComma = /^(\.)?[0-9,-]+(\.\d{0,10})?$/
    //var el = document.getElementById("metric-name-text");
    $('.mit-interval-targets').find('.errorBorder').removeClass('errorBorder')
    $(
      '.invalid-start-date-error,.invalid-end-date-error, .name-error, .target-error'
    ).hide()
    if (
      typeof metricName === 'undefined' ||
      metricName == null ||
      metricName == ''
    ) {
      errors['metricName'] = true
      document.getElementById('krNameError').innerHTML =
        t('Please enter key result');
      let elem = document.getElementById("metric-name-text");
      elem.setAttribute("aria-invalid", "true");
      setTimeout(() => {
        document.getElementById("metric-name-text").focus();
      });
    } else {
      document.getElementById('krNameError').innerHTML = ''
    }

    if (typeof initial_data == '' || initial_data === '') {
      errors['showStartErr'] = true
    } else if (initial_data != '' && !numberWithComma.test(initial_data)) {
      errors['showStartErr'] = true
      this.setState({
        startValueErr: t('Please enter numeric value.'),
      })
    }
    if (target != "" && stretch != "") {
      if ((this.state.dsMetric == 1 || this.state.dsMetric == 9) && parseFloat(stretch) < parseFloat(target)) {
        errors["showStretchErr"] = true;
        this.setState({
          stretchValueErr: "Stretch target should be greater than committed"
        });
      }
      if ((this.state.dsMetric == 2 ||this.state.dsMetric == 8) && parseFloat(stretch) > parseFloat(target)) {
        errors["showStretchErr"] = true;
        this.setState({
          stretchValueErr: "Stretch target should be less than committed"
        });
      }
    }

    if (this.state.dsMetric == 4) {
      if (targetLowerVal == '' || targetLowerVal == null) {
        errors['showTargetLowerErr'] = true
      } else if (
        targetLowerVal != '' &&
        !numberWithComma.test(targetLowerVal)
      ) {
        errors['showTargetLowerErr'] = true
        this.setState({
          lowerLimitErr: t('Please enter numeric value.'),
        })
      }

      if (targetUpperVal == '' || targetUpperVal == null) {
        errors['showTargetUpperErr'] = true
      } else if (
        targetUpperVal != '' &&
        !numberWithComma.test(targetUpperVal)
      ) {
        errors['showTargetUpperErr'] = true
        this.setState({
          upperLimitErr: t('Please enter numeric value.'),
        })
      }

      if (parseFloat(targetLowerVal) > parseFloat(targetUpperVal)) {
        errors['showTargetLowerErr'] = true
        this.setState({
          lowerLimitErr: t('lower limit is greater than upper limit'),
        })
      }
    }
    if( this.state.isRequirdCustomOkr && this.state.isRequirdCustomOkr.length>0){
      errors["customokr"] = t(`Please enter required field`);
      this.setState({isCustomSave:this.state.isRequirdCustomOkr})
      setTimeout(() => {
        this.setState({customFiledRequired:true})
        document.querySelector('#cutomobj').scrollIntoView({
          behavior: 'smooth',
        })
      }, 200)

    } else {
      if (this.state.isStretchEnabled) {
        if ((target == '' || target == null || target == undefined) && (stretch == '' || stretch == null || stretch == undefined)) {
          if (!errors['showStartErr']) {
            errors['showTargetErr'] = errors['showStretchErr'] = true
          }
          $('.krRightPaneContent').parent().animate({ scrollTop: 100 })
        }
        if (stretch && !numberWithComma.test(stretch)) {
          if (!errors['showStartErr']) {
            errors['showStretchErr'] = true
            $('.krRightPaneContent').parent().animate({ scrollTop: 100 })
            this.setState({
              stretchValueErr: 'Please enter numeric value.',
            })
          }
        }
      } else {
        if (target == '' || target == null) {
          if (!errors['showStartErr']) {
            errors['showTargetErr'] = true
          }
          $('.krRightPaneContent').parent().animate({ scrollTop: 100 })
        }
      }

      if (target && !numberWithComma.test(target)) {
        if (!errors['showStartErr']) {
          errors['showTargetErr'] = true
          $('.krRightPaneContent').parent().animate({ scrollTop: 100 })
          this.setState({
            targetValueErr: t('Please enter numeric value.'),
          })
        }
      }
      if (this.state.dsMetric == 1 &&
          ((!this.state.isStretchEnabled &&
          parseFloat(initial_data) > parseFloat(target)) ||
          (this.state.isStretchEnabled &&
          (parseFloat(initial_data) > parseFloat(target) || parseFloat(initial_data) > parseFloat(stretch))))
      ) {
        errors['showStartErr'] = true
        if (this.state.isStretchEnabled && parseFloat(initial_data) > parseFloat(target)) {
          errors['showTargetHightlightErr'] = true
        }
        if (this.state.isStretchEnabled && parseFloat(initial_data) > parseFloat(stretch)) {
          errors['showStretchHightlightErr'] = true
        }
        $('.krRightPaneContent').parent().animate({ scrollTop: 100 })
        this.setState({
          startValueErr: t('Starting value should be less than target'),
        })
      } else if (this.state.dsMetric == 2 &&
        ((!this.state.isStretchEnabled &&
        parseFloat(initial_data) < parseFloat(target)) ||
        (this.state.isStretchEnabled &&
        (parseFloat(initial_data) < parseFloat(target) || parseFloat(initial_data) < parseFloat(stretch))))
      ) {
        errors['showStartErr'] =  true
        if (this.state.isStretchEnabled && parseFloat(initial_data) < parseFloat(target)) {
          errors['showTargetHightlightErr'] = true
        }
        if (this.state.isStretchEnabled && parseFloat(initial_data) < parseFloat(stretch)) {
          errors['showStretchHightlightErr'] = true
        }
        $('.krRightPaneContent').parent().animate({ scrollTop: 100 })
        this.setState({
          startValueErr: t('Starting value should be greater than target'),
        })
      }
    }

    let error = this._isValidDate()
    const {
      noChildKRError = false,
      startError = false,
      overlapError = false,
    } = error || {}
    if (noChildKRError || startError || overlapError) {
      $('.krRightPaneContent').parent().animate({ scrollTop: 100 })
      if (noChildKRError) {
        return this.setState({
          mitChildError: true,
          mitChildErrorMsg: t('Please ensure that intervals are created'),
        })
      } else if (startError) {
        return this.setState({
          mitChildError: true,
          mitChildErrorMsg: t(`Please ensure start dates are before end dates for each interval`),
        })
      } else if (overlapError) {
        return this.setState({
          mitChildError: true,
          mitChildErrorMsg: t(`Please ensure dates are valid and don't overlap`),
        })
      }
    }
    if (isAnnualMit && this.state.mitType == '') {
      this.props.toggleMitTypeSelectError()
      return false
    }
    let validateOwner = this.state.data_provider ? this.state.data_provider: this.props.realOwner;
    let validateFlag =  this.state.data_provider.id ? this.props.item.is_owner_rol : this.props.item.is_real_owner_rol;
    if (validateOwner) {
      if (validateFlag && this.state.checkRolFlag) {
        errors['owner_validation'] = `${validateOwner.name} has Read Only access and can't be assigned KRs`;
        this.setState({ checkRolFlag: false });
      } else {
        delete errors['owner_validation'];
      }
    }

    // Validate realOwner using role flags or ownerList
    if (this.props.realOwner && this.props.realOwner.id) {
      if (this.state.checkRolFlag) {
        if (this.props.item && this.props.item.is_real_owner_rol !== undefined && this.props.item.is_real_owner_rol ) {
          errors['real_owner_validation'] = `${this.props.realOwner.name} has Read Only access and can't be assigned KRs`;
          this.props.showRolErr(true);
          this.setState({ checkRolFlag: false });
        } else {
          this.props.showRolErr(false);
        }
      } else {
        this.props.showRolErr(false);
      }
    }

    if (Object.keys(errors).length) {
      this.setState({ errors })
      if (errors.metricName) {
        $('.krRightPaneContent').parent().animate({ scrollTop: 0 })
      }
    } else {
      reactLoader(true)
      let params = {}
      if (this.state.dsMetric == 4) {
        params.lower_limit = this.state.lower_limit
        params.upper_limit = this.state.upper_limit
        params.progress_type = 1
        params.child_progress_type = 1
      } else {
        params.target = this.state.target
        params.progress_type = this.state.progType
        params.child_progress_type = this.state.childProgType
        if(this.state.isStretchEnabled) {
          params.stretchTarget = this.state.stretch
        }
      }
      params.name = metricName
      params.description = metricNote
      params.owner = this.state.data_provider.id
        ? this.state.data_provider.id
        : this.props.realOwner.id
      params.metric = this.state.measureType
      params.initial_data = this.state.initial_data
      params.counting = this.state.dsMetric
      params.interval = this.state.intervalType
      let nlpIds =this.state.selectednlplTagsName && this.state.selectednlplTagsName.length ? this.state.selectednlplTagsName : ['']
      let tagids=this.state.tags.length ? this.state.tags : ['']
      let finalTagsIds = [...nlpIds,...tagids]
      params.krTagIds = finalTagsIds;
      params.customField = JSON.stringify(this.props.customFieldsData);
      if (isWeeklyInterval(this.state.intervalType)) {
        params.weekly_update_day = this.state.dayType
      }
      if(isQuarterlyAggregationMitType(this.state.mitType)){
        params.source = 14;
      }else{
        params.source = this.props.kpiType == 'ds' ? 13 : 12;
      }
      params.real_owner = this.props.showRealOwner
        ? this.props.realOwner.id
        : params.owner;
        let coOwners = this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [];
      params.coOwners = coOwners.length > 0 ? Array.prototype.map
        .call(coOwners, s => s.id)
        .toString() : '';
      params.progress_consider = this.state.Exclude ? 0 : 1

      let teaMperArr = [], bizPerArr = [];
      if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
        const { permission_teams = [], permission_biz = []} = this.props.goalDetails;
        if (Array.isArray(permission_teams) && permission_teams.length) {
          teaMperArr = permission_teams.map(val => val.id);
        }
        if (Array.isArray(permission_biz) && permission_biz.length) {
          bizPerArr = permission_biz.map(val => val.id);
        }
      } else {
        if (
          this.state.teamPermissionSelected &&
          this.state.teamPermissionSelected.length > 0
        ) {
          teaMperArr = this.state.teamPermissionSelected.map((val) => val.id)
        }
        if (
          this.state.bizPermissionSelected &&
          this.state.bizPermissionSelected.length > 0
        ) {
          bizPerArr = this.state.bizPermissionSelected.map((val) => val.id)
        }
      }
      params.permission_teams = teaMperArr
      params.permission_biz = bizPerArr

      if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
        params.permission = this.props.goalDetails.permission
      } else {
        params.permission = Array.prototype.map
          .call(this.state.permissionstate, (s) => s)
          .toString() // "A,B,C";
      }

      let goalId = this.props.goalDetails.id
      if (this.props.item && this.props.item.id) {
        params.id = this.props.item.id
      }
      let { actions } = this.props
      params['child_krs'] = []

      let krAlignSel = this.state.krAlingSelected
      let dependentKrsSel = this.state.krDependenciesSelected
      let krAligns = []
      let dependentKrs = []

      if (Object.keys(krAlignSel).length > 0) {
        krAlignSel.map((item) => {
          krAligns.push(item.id)
        })
      }

      if (Object.keys(dependentKrsSel).length > 0) {
        dependentKrsSel.map((item) => {
          dependentKrs.push(item.id)
        })
      }
      params.krAligns = krAligns
      params.dependentKr = dependentKrs
      if (!this.state.isStretchEnabled) {
        params.committed_target = this.state.committedKRFlag == 1 ? 1 : 0
      }
      params.quarter_target_type = quarterTargetType[this.state.mitType]
      let { dateSegments = [], mitType } = this.state
      const segmentsLength = dateSegments.length
      const segmentErrors = []
      if (segmentsLength) {
        const { start_date, target_date } = this.props.goalDetails
        for (let i = 0; i < segmentsLength; i++) {
          const {
            intervalName = '',
            targetValue = '',
            quarterName,
            startDate = '',
            endDate = '',
            krId,
            status = 1,
            source = 1,
          } = dateSegments[i];
          const name = intervalName.trim();
          const childTarget = (typeof targetValue == "string") ? targetValue.trim() : targetValue;
          let obj = {
            name,
            target : childTarget,
            quarterName,
            status
          };
          if (krId !== '' && krId) {
            obj['id'] = krId
          }
          if (isQuarterlyAggregationMitType(mitType)) {
            if (name === '') {
              segmentErrors[i] = { nameError: true }
              break
            }

            if (source != 2 && childTarget === '') {
              segmentErrors[i] = { targetError: true }
              break
            }
            let childInitialData = '';
            let targetForValidation = '';
            let resultDirectionValue = '';
            if (this.state.dsMetric != 8 && this.state.dsMetric != 9) { // Should not exceed and fall below need not pass this as IV is not tied up to target
              console.log("Validating Child KR");
              if (typeof child_krs[i] !== 'undefined') {
                childInitialData = child_krs[i]['initial_data'] ? child_krs[i]['initial_data']  : child_krs[i]['trackInitialData'] ? child_krs[i]['trackInitialData'] : '';
                targetForValidation = child_krs[i]['target'] ? child_krs[i]['target'] : child_krs[i]['stretch_target'];
                resultDirectionValue = getMitChildCounting(
                  mitType,
                  this.state.dsMetric,
                  child_krs[i]?.counting,
                );
              } else if (typeof  dateSegments[i] !== 'undefined') {
                childInitialData = typeof dateSegments[i]['initialData'] !== 'undefined' ? dateSegments[i]['initialData'] : mitType == MIT_TYPE.TRACK_PROGRESSION ? initial_data : '';
                targetForValidation = obj.target ? obj.target : '';
                resultDirectionValue = getMitChildCounting(mitType, this.state.dsMetric);
              }
              if (childInitialData && targetForValidation) {
                if (resultDirectionValue == krdetailConstants.METRIC_COUNTING_UP) { // Increase to validation
                  if (parseFloat(childInitialData) > parseFloat(targetForValidation)) {
                    segmentErrors[i] = { targetResultDirectionError: true }
                    segmentErrors[i]['targetResultDirectionMsg'] = 'Target value should be less than start value';
                    break
                  }
                }
                if (resultDirectionValue == krdetailConstants.METRIC_COUNTING_DOWN) { // Decrease to validation
                  if (parseFloat(childInitialData) < parseFloat(targetForValidation)) {
                    segmentErrors[i] = { targetResultDirectionError: true }
                    segmentErrors[i]['targetResultDirectionMsg'] = 'Target value should be greater than start value';
                    break
                  }
                }
              }
            }

            obj = (child_krs[i] ? Object.assign(obj, child_krs[i]) : obj);
            obj = this.deleteProperties(obj);
            if(obj['source'] == 8 && !obj['ext_source_unit'] && this.checkExcludedType(obj['ext_app_id'])){
              obj.external_app_sources = obj.external_app_sources[0] ? obj.external_app_sources[0] : obj.external_app_sources;
              const projectObj = {
                name: obj.external_app_sources.ext_app_link_name,
                id: obj.external_app_sources.ext_app_link_id,
                type: obj.external_app_sources.ext_app_link_type
              }
              let extData = JSON.parse(obj.external_app_sources.data);
              const externalData = {...extData, automateTargetFlag : this.state.automateTargetFlag};
              obj = {
                ... obj,
                ... {
                  instance_url: obj.external_app_sources.instance_url,
                  project_ids: [JSON.stringify(projectObj)],
                  ext_source_data: externalData,
                  external_app_sources : obj.external_app_sources,
                  ext_source_unit: {
                    metric: this.state.metricType,
                    progress: externalData.value,
                    target: externalData.total
                  }
                }
              }
            }
            obj['start_date'] = moment(startDate).format('MM/DD/YYYY')
            obj['end_date'] = moment(endDate).format('MM/DD/YYYY')
            if (!this.state.isStretchEnabled) {
              obj['committed_target'] = params.committed_target;
            }
            obj['source'] = (child_krs[i] ? child_krs[i].source : 1);
            obj['owner'] = (child_krs[i] ? child_krs[i].owner : params.owner);
            obj['real_owner'] = (child_krs[i] ? child_krs[i].real_owner : params.real_owner);
            obj['progress_type'] = (child_krs[i] ? child_krs[i].progress_type : this.getProgressType(this.state.mitType));
            obj['progress_consider'] = (child_krs[i] ? child_krs[i].progress_consider : params.progress_consider);
            obj['permission'] = (child_krs[i] ? child_krs[i].permission : params.permission);
            obj['interval'] = (child_krs[i] ? child_krs[i].interval : params.interval);
            // MR-8337: parent/child direction must match; legacy Add-up + parent Decrease-to keeps Increase-to on children
            obj['counting'] = getMitChildCounting(
              this.state.mitType,
              this.state.dsMetric,
              child_krs[i]?.counting,
            );
            if (isWeeklyInterval(this.state.intervalType)) {
              obj['weekly_update_day'] = this.state.dayType;
            }
            obj['coOwners'] = params.coOwners;
            params['child_krs'][i] = obj
          } else if (mitType == MIT_TYPE.CUSTOM || mitType == '') {
            if (startDate.trim() === '') {
              segmentErrors[i] = { startDateError: true }
              break
            }
            if (endDate.trim() === '') {
              segmentErrors[i] = { endDateError: true }
              break
            }
            if (
              isInvalidCustomMitStartDate(
                startDate,
                this.props.goalDetails,
                dateSegments,
                i,
              )
            ) {
              console.log(
                'invalid',
                !parseUtcSegmentDate(startDate.trim()).isValid(),
                parseUtcSegmentDate(startDate.trim()).isBefore(
                  parseUtcGoalDate(this.props.goalDetails.start_date),
                  'day',
                ),
                parseUtcSegmentDate(startDate.trim()).isAfter(
                  parseUtcGoalDate(this.props.goalDetails.target_date),
                  'day',
                ),
              )
              segmentErrors[i] = { startDateError: true }
              break
            }
            if (
              isInvalidCustomMitEndDate(endDate, this.props.goalDetails)
            ) {
              segmentErrors[i] = { endDateError: true }
              break
            }
            if (name === '') {
              segmentErrors[i] = { nameError: true }
              break
            }
            if (this.state.isStretchEnabled) {
              if (obj.target === '') {
                segmentErrors[i] = { targetError: true }
                break
              }
            } else {
              if (target === '') {
                segmentErrors[i] = { targetError: true }
                break
              }
            }

            obj['start_date'] = formatUtcSegmentForSave(startDate)
            obj['end_date'] = formatUtcSegmentForSave(endDate)
            // MR-8337: parent/child direction must match; legacy Add-up + parent Decrease-to keeps Increase-to on children
            obj['counting'] = getMitChildCounting(this.state.mitType, this.state.dsMetric)
            params['child_krs'][i] = obj
          }
        }
      }

      if (segmentErrors.length) {
        removeReactLoader()
        this.setState(
          {
            segmentErrors,
          },
          () => {
            $('.krRightPaneContent').parent().animate({ scrollTop: 300 })
          }
        )
      } else if (krType != lastType && addEditFlag) {
        removeReactLoader()
        this.setState({
          confirmPopup: true,
        })
      } else if (
        addEditFlag &&
        (((isQuarterlyAggregationMitType(this.state.mitTypeBeforeEdit)) &&
          (this.state.mitType == MIT_TYPE.CUSTOM ||
            this.state.mitType == MIT_TYPE.SUPPORTING_QUARTER_KR)) ||
          (isQuarterlyAggregationMitType(this.state.mitType) &&
            (this.state.mitTypeBeforeEdit == MIT_TYPE.CUSTOM ||
              this.state.mitTypeBeforeEdit == MIT_TYPE.SUPPORTING_QUARTER_KR)))
      ) {
        removeReactLoader()
        this.setState({
          mitTypeChangeAlert: true,
        })
      } else if (this.state.intervalType != this.props.item.interval && this.props.addEditFlag) {
        removeReactLoader()
        this.setState({
          intervalConfirmPopup: true
        })
      } else {
        this.GoalServices.addEditKr({
          goalId: goalId,
          metric: params,
          dontStringify: true,
        }).then((response) => {
          removeReactLoader();
          if (response.data) {
            if (!this.props.onlyMetEdit) {
              let result = response.data.data
              let krWeightage = null
              if (result.krWeightage) {
                krWeightage = result.krWeightage
                delete result['krWeightage']
              }
              result = {
                clusterItems: this.props.clusterData,
                clusterCount: this.props.clusterData.length,
                ...result,
              }
              if (this.state.krId != '') {
                actions.editNewKr(this.state.krId, result)
              } else {
                actions.addNewKr(result)
              }
              if (krWeightage) {
                this.props.MetricChangeWeight(krWeightage)
              }
            }
            if(response.data.data.source == 14){
              this.syncKrsWithKpiData(params, response).then((result) => console.log("result", result));
            }
            if (callback && typeof callback === 'function') {
              callback(response.data.data);
            } else {
              this.props.closeKrRightPane(true);
            }
          }
        })
      }
    }
  }

  exitDeleteModal() {
    //console.log('exitmodel');
    this.setState({ confirmPopup: false, intervalConfirmPopup: false })
  }

  isSaveCustom(isVal){
    let arr=[];
    let j=0;
    let keyArrCategory=[]
    let valArray = []
    isVal && Object.keys(isVal).forEach((v)=>{
      j++;
      isVal[v]["customFields"]&&
      Object.keys(isVal[v]["customFields"]).forEach(objv=>{
        keyArrCategory.push(objv)
        if(isVal[v]["customFields"][objv]['is_required']=='1'
        &&( isVal[v]["customFields"][objv]["text"]  ==undefined || isVal[v]["customFields"][objv]["text"]  ==[])
        ){
             arr.push(objv,v)
            }
        if(isVal[v]["customFields"][objv]["text"]){
          valArray.push(isVal[v]["customFields"][objv]["text"])
        }else{
          valArray.push('')
            }
      })
      if(j==Object.keys(isVal).length){
        this.setState({isRequirdCustomOkr:[...arr]})
      }
      let finalDataArray=[]
      for(let i=0;i<valArray.length;i++){
        if(Array.isArray(valArray[i])){
          valArray[i].forEach(val => {
            finalDataArray.push({id:keyArrCategory[i],val:val.name,object_type:'6'})
          })
        }
        else{
          finalDataArray.push({id:keyArrCategory[i],val:valArray[i],object_type:'6'})
        }

      }
      const tempData=finalDataArray
    })

  }

    isRequiredCustomOkrFiled(isVal,id){
      let cust_id=this.state.isCustomSave.find((u) => u == id);
      let ar=this.state.isCustomSave ? this.state.isCustomSave:'';
      let fr= ar.filter(
          (u) => u != cust_id
        )
      this.setState({isCustomSave:fr})
      this.isSaveCustom(isVal)
      this.setState({customInputData:isVal})
  }

  saveItems() {
    reactLoader(true)
    let metricName = $('#metric-name-text').val()
    let metricNote = this.props.krNote
    let params = {}

    let krAlignSel = this.state.krAlingSelected
    let dependentKrsSel = this.state.krDependenciesSelected
    let krAligns = []
    let dependentKrs = []

    if (Object.keys(krAlignSel).length > 0) {
      krAlignSel.map((item) => {
        krAligns.push(item.id)
      })
    }

    if (Object.keys(dependentKrsSel).length > 0) {
      dependentKrsSel.map((item) => {
        dependentKrs.push(item.id)
      })
    }
    params.krAligns = krAligns
    params.dependentKr = dependentKrs
    params.retainUpdates = this.state.selectedType ? this.state.selectedType : '' ;
    if (this.state.dsMetric == 4) {
      params.lower_limit = this.state.lower_limit
      params.upper_limit = this.state.upper_limit
      params.progress_type = 1
      params.child_progress_type = 1
    } else {
      params.target = this.state.target
      params.progress_type = this.state.progType
      params.child_progress_type = this.state.childProgType
      if(this.state.isStretchEnabled) {
        params.stretchTarget = this.state.stretch
      }
    }
    params.name = metricName
    params.description = metricNote
    params.owner = this.state.data_provider.id
      ? this.state.data_provider.id
      : this.props.realOwner.id
    params.metric = this.state.measureType
    params.initial_data = this.state.initial_data
    params.counting = this.state.dsMetric
    params.interval = this.state.intervalType
    params.customField = JSON.stringify(this.props.customFieldsData);

    if (isWeeklyInterval(this.state.intervalType)) {
      params.weekly_update_day = this.state.dayType
    }
    if(isQuarterlyAggregationMitType(this.state.mitType)){
      params.source = 14;
    }else{
      params.source = this.props.kpiType == 'ds' ? 13 : 12;
    }
    params.real_owner = this.props.showRealOwner
        ? this.props.realOwner.id
        : params.owner;
    let coOwners = this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [];
    params.coOwners = coOwners.length > 0 ? Array.prototype.map
      .call(coOwners, s => s.id)
      .toString() : '';
    params.progress_consider = this.state.Exclude ? 0 : 1
    params.quarter_target_type =
      this.props.quarterTargetType[this.state.mitType]

    let teaMperArr = [], bizPerArr = [];
    if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
      const { permission_teams = [], permission_biz = []} = this.props.goalDetails;
      if (Array.isArray(permission_teams) && permission_teams.length) {
        teaMperArr = permission_teams.map(val => val.id);
      }
      if (Array.isArray(permission_biz) && permission_biz.length) {
        bizPerArr = permission_biz.map(val => val.id);
      }
    } else {
      if (
        this.state.teamPermissionSelected &&
        this.state.teamPermissionSelected.length > 0
      ) {
        teaMperArr = this.state.teamPermissionSelected.map(val => val.id)
      }
      if (
        this.state.bizPermissionSelected &&
        this.state.bizPermissionSelected.length > 0
      ) {
        bizPerArr = this.state.bizPermissionSelected.map(val => val.id)
      }
    }
    params.permission_teams = teaMperArr
    params.permission_biz = bizPerArr

    if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
      params.permission = this.props.goalDetails.permission
    } else {
      params.permission = Array.prototype.map
        .call(this.state.permissionstate, (s) => s)
        .toString() // "A,B,C";
    }

    let goalId = this.props.goalDetails.id
    if (this.props.item && this.props.item.id) {
      params.id = this.props.item.id
    }
    let { actions } = this.props
    params['child_krs'] = []
    let child_krs = $('.mit-interval-targets .w100')
    const child_krs_state = [...this.state.child_krs];
    // Get the list of all the child kr's with the corresponding start and end dates
    for (let i = 0; i < child_krs.length; i++) {
      //{"start_date":"5/28/2019","end_date":"5/29/2019","name":"child MIT  1 1 ","target":"101"}
      if (
        isQuarterlyAggregationMitType(this.state.mitType)
      ) {
        let obj = {}
        let startVal = this.state.dateSegments[i].startDate
        let endVal = this.state.dateSegments[i].endDate
        let name = $(child_krs[i]).find("input[name='intervalName']").val()
        let quarterName = $(child_krs[i])
          .find("input[name='quarterName']")
          .val()
        let target = $(child_krs[i]).find("input[name='targetValue']").val()
        let krId = $(child_krs[i]).find('.child-kr-id').data('child-kr-id')
        if (name.trim() === '') {
          $(child_krs[i])
            .find("input[name='intervalName']")
            .addClass('errorBorder')
          $(child_krs[i]).find('.name-error').show()
          $(child_krs[i]).find('.invalid-end-date-error').hide()
          $(child_krs[i]).find('.invalid-start-date-error').hide()
          removeReactLoader()
          $('.krRightPaneContent').parent().animate({ scrollTop: 300 })
          return
        } else if (target.trim() === '') {
          $(child_krs[i])
            .find("input[name='targetValue']")
            .addClass('errorBorder')
          $(child_krs[i]).find('.target-error').show()
          removeReactLoader()
          $('.krRightPaneContent').parent().animate({ scrollTop: 300 })
          return
        }
        obj['start_date'] = moment(startVal).format('MM/DD/YYYY')
        obj['end_date'] = moment(endVal).format('MM/DD/YYYY')
        obj['name'] = name
        obj['target'] = target
        obj['quarterName'] = quarterName
        if (krId !== '') {
          obj['id'] = krId
        }
        obj = (child_krs_state[i] ? Object.assign(obj, child_krs_state[i]) : obj);
        obj = this.deleteProperties(obj);
        if(obj['source'] == 8 && !obj['ext_source_unit'] && this.checkExcludedType(obj['ext_app_id'])){
          obj.external_app_sources = obj.external_app_sources[0] ? obj.external_app_sources[0] : obj.external_app_sources;
          const projectObj = {
            name: obj.external_app_sources.ext_app_link_name,
            id: obj.external_app_sources.ext_app_link_id,
            type: obj.external_app_sources.ext_app_link_type
          }
          let extData = JSON.parse(obj.external_app_sources.data);
          const externalData = {...extData, automateTargetFlag : this.state.automateTargetFlag};
          obj = {
            ... obj,
            ... {
              instance_url: obj.external_app_sources.instance_url,
              project_ids: [JSON.stringify(projectObj)],
              ext_source_data: externalData,
              external_app_sources : obj.external_app_sources,
              ext_source_unit: {
                metric: this.state.metricType,
                progress: externalData.value,
                target: externalData.total
              }
            }
          }
        }
        obj['committed_target'] = params.committed_target;
        obj['source'] = (child_krs_state[i] ? child_krs_state[i].source : 1);
        obj['owner'] = (child_krs_state[i] ? child_krs_state[i].owner : params.owner);
        obj['real_owner'] = (child_krs_state[i] ? child_krs_state[i].real_owner : params.real_owner);
        obj['progress_type'] = (child_krs_state[i] ? child_krs_state[i].progress_type : this.getProgressType(this.state.mitType));
        obj['progress_consider'] = (child_krs_state[i] ? child_krs_state[i].progress_consider : params.progress_consider);
        obj['permission'] = (child_krs_state[i] ? child_krs_state[i].permission : params.permission);
        obj['interval'] = (child_krs_state[i] ? child_krs_state[i].interval : params.interval);
        // MR-8337: parent/child direction must match; legacy Add-up + parent Decrease-to keeps Increase-to on children
        obj['counting'] = getMitChildCounting(
          this.state.mitType,
          this.state.dsMetric,
          child_krs_state[i]?.counting,
        );

        if (isWeeklyInterval(this.state.intervalType)) {
          obj['weekly_update_day'] = this.state.dayType
        }
        obj['coOwners'] = params.coOwners;
        params['child_krs'][i] = obj;
      } else if (this.state.mitType == MIT_TYPE.CUSTOM || this.state.mitType == '') {
        let obj = {}
        let startVal = $(child_krs[i])
          .find("input[name='goal_start_date']")
          .val()
        if (
          isInvalidCustomMitStartDate(
            startVal,
            this.props.goalDetails,
            this.state.dateSegments,
            i,
          )
        ) {
          $(child_krs[i])
            .find('.aEStartDate .DayPickerInput')
            .addClass('errorBorder')
          $(child_krs[i]).find('.invalid-start-date-error').show()
          removeReactLoader()
          $('.krRightPaneContent').parent().animate({ scrollTop: 300 })
          return
        }
        let endVal = $(child_krs[i]).find("input[name='goal_end_date']").val()
        if (
          isInvalidCustomMitEndDate(endVal, this.props.goalDetails)
        ) {
          $(child_krs[i])
            .find('.aEEndDate .DayPickerInput')
            .addClass('errorBorder')
          $(child_krs[i]).find('.invalid-end-date-error').show()
          removeReactLoader()
          $('.krRightPaneContent').parent().animate({ scrollTop: 300 })
          return
        }
        let name = $(child_krs[i]).find("input[name='intervalName']").val()
        let target = $(child_krs[i]).find("input[name='targetValue']").val()
        let krId = $(child_krs[i]).find('.child-kr-id').data('child-kr-id')
        if (name.trim() === '') {
          $(child_krs[i])
            .find("input[name='intervalName']")
            .addClass('errorBorder')
          $(child_krs[i]).find('.name-error').show()
          $(child_krs[i]).find('.invalid-end-date-error').hide()
          $(child_krs[i]).find('.invalid-start-date-error').hide()
          removeReactLoader()
          $('.krRightPaneContent').parent().animate({ scrollTop: 300 })
          return
        } else if (target.trim() === '') {
          $(child_krs[i])
            .find("input[name='targetValue']")
            .addClass('errorBorder')
          $(child_krs[i]).find('.target-error').show()
          removeReactLoader()
          $('.krRightPaneContent').parent().animate({ scrollTop: 300 })
          return
        } else if (startVal.trim() === '') {
          $(child_krs[i])
            .find("input[name='goal_start_date']")
            .addClass('errorBorder')
          removeReactLoader()
          $('.krRightPaneContent').parent().animate({ scrollTop: 300 })
          return
        } else if (endVal.trim() === '') {
          $(child_krs[i])
            .find("input[name='goal_end_date']")
            .addClass('errorBorder')
          removeReactLoader()
          $('.krRightPaneContent').parent().animate({ scrollTop: 300 })
          return
        }
        obj['start_date'] = formatUtcSegmentForSave(startVal)
        obj['end_date'] = formatUtcSegmentForSave(endVal)
        obj['name'] = name
        obj['target'] = target
        obj['coOwners'] = params.coOwners
        if (krId !== '') {
          obj['id'] = krId
        }
        // MR-8337: parent/child direction must match; legacy Add-up + parent Decrease-to keeps Increase-to on children
        obj['counting'] = getMitChildCounting(this.state.mitType, this.state.dsMetric)
        params['child_krs'][i] = obj
      }
    }

    this.GoalServices.addEditKr({
      goalId: goalId,
      metric: params,
      dontStringify: true,
    }).then((response) => {
      removeReactLoader()
      if (response.data) {
        if (!this.props.onlyMetEdit) {
          let result = response.data.data
          let krWeightage = null
          if (result.krWeightage) {
            krWeightage = result.krWeightage
            delete result['krWeightage']
          }
          result = {
            clusterItems: this.props.clusterData,
            clusterCount: this.props.clusterData.length,
            ...result,
          }
          //console.log("response.data->", response.data.data);
          if (this.state.krId != '') {
            //console.log(this.state.krId);
            actions.editNewKr(this.state.krId, result)
          } else {
            actions.addNewKr(result)
          }
          if (krWeightage) {
            this.props.MetricChangeWeight(krWeightage)
          }
        }

        if(response.data.data.source == 14){
          this.syncKrsWithKpiData(params, response).then((result) => console.log("result", result));
        }

        this.props.closeKrRightPane(true)
      }
        // this.GoalServices.triggerGoalMetricDetails({ goalId });
    })
  }

  async syncKrsWithKpiData(params, response) {
    let wobotoken = '';
    let basicInterval = IntervalTexts;
    for (let i = 0; i < response.data.data.child_krs.length; i++) {
      if(params['child_krs'][i].clientId != null && response.data.data.child_krs[i]['source'] == 8 && this.checkExcludedType(response.data.data.child_krs[i]['ext_app_id'])){
        if (params['child_krs'][i].clientId != null) {
          let payload = {
            userConnectionUrn: params['child_krs'][i].connectionUrn,
            woboObjectId: parseInt(response.data.data.child_krs[i].id),
            woboObjectType: 'metric',
            externalObjectId:  response.data.data.child_krs[i].external_app_sources[0].ext_app_link_id,
            externalObjectType: response.data.data.child_krs[i].external_app_sources[0].ext_app_link_type,
            updateFrequency: basicInterval[response.data.data.child_krs[i].interval],
            externalObjectExtra: JSON.parse(response.data.data.child_krs[i].external_app_sources[0].data),
            data: response.data.data.child_krs[i]['ext_app_id'] == 22 ? {value: params['child_krs'][i]['ext_source_data']['value'], label: params['child_krs'][i]['ext_source_data']['value'] } : {value: params['child_krs'][i]['ext_source_data']['value'] },
          }
          if (!params['child_krs'][i].isNew) {
            continue;
          }

          if (wobotoken == '') {
            wobotoken = await this.getUserAccessToken(params['child_krs'][i].clientId);
          }

          const kpiDataId = params['child_krs'][i]?.kpiDataId || null;
          if (kpiDataId) {
            await this.GoalServices.patchKpiData(kpiDataId, { woboObjectId: response.data.data.child_krs[i].id }, wobotoken)
          } else {
            await this.GoalServices.createKpiData(payload,wobotoken)
          }
        }
      }
    }
    return true;
  }

  /**
   * Validates endDate of child KR is always greater than start date and there is no overlap
   * @param startDate
   * @param endDate
   * @private
   */
  _isValidDate = () => {
    let { dateSegments = [] } = this.state
    let shallowCopyDateSegments = [].concat(dateSegments)
    let dLength = shallowCopyDateSegments.length
    if (!dLength) {
      return { noChildKRError: true }
    }
    // Sorting all my date values by start date and then checking to make sure end date is always > than start date
    let sortedDateSegments = shallowCopyDateSegments.sort((a, b) => {
      return parseUtcSegmentDate(a.startDate).valueOf()
        - parseUtcSegmentDate(b.startDate).valueOf()
    })
    if (dLength === 1) {
      if (
        !parseUtcSegmentDate(sortedDateSegments[0]['startDate']).isBefore(
          parseUtcSegmentDate(sortedDateSegments[0]['endDate']),
        )
      ) {
        return { startError: true }
      }
    }
    for (let i = 1; i < dLength; i++) {
      if (
        !parseUtcSegmentDate(sortedDateSegments[i - 1]['startDate']).isBefore(
          parseUtcSegmentDate(sortedDateSegments[i - 1]['endDate']),
        )
      ) {
        return { startError: true }
      }
      if (
        sortedDateSegments[i]['startDate'] === '' ||
        sortedDateSegments[i - 1]['endDate'] === ''
      ) {
        continue
      }
      if (
        !parseUtcSegmentDate(sortedDateSegments[i]['startDate']).isAfter(
          parseUtcSegmentDate(sortedDateSegments[i - 1]['endDate']),
        ) ||
        !parseUtcSegmentDate(sortedDateSegments[i]['endDate']).isAfter(
          parseUtcSegmentDate(sortedDateSegments[i]['startDate']),
        )
      ) {
        return { overlapError: true }
      }
    }
    return { noError: true }
  }

  /**
   * Takes the index of the child KR and deletes the obj from array
   * @param index {required}
   * @private
   */
  _deleteInterval = (index) => {
    let { dateSegments, child_krs } = this.state
    dateSegments.splice(index, 1)
    child_krs.splice(index, 1);
    if (index === dateSegments.length) {
      this.setState({
        dateSegments,
        child_krs,
        disableAddingInterval: false,
      })
    } else {
      this.setState({ dateSegments, child_krs })
    }
  }

  /**
   * Use this function to create a new dateSegments set that consists of
   * start and end date objects that each last for 1 quarter
   * When delete happens, we remove that specific index from the array
   * and setState again.
   */
  _addNewInterval = () => {
    let { dateSegments } = this.state
    const lastSegment = Array.isArray(dateSegments) ? dateSegments.slice(-1)[0] : undefined

    if (!lastSegment || lastSegment.endDate == null) {
      const fallback = createDateSegmentsFallback(
        this.props.goalDetails.start_date,
        this.props.goalDetails.target_date
      )
      dateSegments = Array.isArray(dateSegments) ? [...dateSegments] : []
      dateSegments.push(fallback[0])
      const targetReached = moment(fallback[0].endDate).isSame(
        moment(this.props.goalDetails.target_date),
        'day'
      )
      this.setState({
        dateSegments,
        disableAddingInterval: targetReached,
      })
      return
    }

    let lastEndDate = lastSegment.endDate
    let newStartDate = moment(lastEndDate).isValid()
      ? moment(lastEndDate).add(1, 'days').format('MMM DD, YYYY')
      : ''
    let newEndDate = moment(newStartDate).isValid()
      ? moment(newStartDate).endOf('month').format('MMM DD, YYYY')
      : ''

    // CHECK TO SEE IF NEW START DATE IS OVER PARENT END DATE
    if (
      moment(newStartDate).isAfter(moment(this.props.goalDetails.target_date))
    ) {
      this.setState({
        disableAddingInterval: true,
      })
    } else {
      if (moment(newEndDate).isAfter(this.props.goalDetails.target_date)) {
        dateSegments.push({
          startDate: newStartDate,
          endDate: moment(this.props.goalDetails.target_date).format(
            'MMM DD, YYYY'
          ),
        })
        this.setState({ dateSegments, disableAddingInterval: true })
      } else if (
        moment(newEndDate).isSame(this.props.goalDetails.target_date)
      ) {
        dateSegments.push({
          startDate: newStartDate,
          endDate: newEndDate,
        })
        this.setState({ dateSegments, disableAddingInterval: true })
      } else {
        dateSegments.push({
          startDate: newStartDate,
          endDate: newEndDate,
        })
        this.setState({ dateSegments })
      }
    }
  }

  handleEndDateChange(selectedDay, index) {
    let { dateSegments } = this.state
    dateSegments[index]['endDate'] = moment(selectedDay).format('MMM DD, YYYY')
    for (let i = index; i < dateSegments.length - 1; i++) {
      if (
        !moment(dateSegments[i + 1]['startDate']).isAfter(
          moment(dateSegments[i]['endDate'])
        )
      ) {
        dateSegments[i + 1]['startDate'] = moment(dateSegments[i]['endDate'])
          .add(1, 'days')
          .format('MMM DD, YYYY')
      }
      if (
        !moment(dateSegments[i + 1]['endDate']).isAfter(
          moment(dateSegments[i]['endDate'])
        )
      ) {
        dateSegments[i + 1]['endDate'] = moment(dateSegments[i]['endDate'])
          .add(1, 'days')
          .format('MMM DD, YYYY')
      }
    }
    const segmentErrors = this.state.segmentErrors
    if (
      typeof segmentErrors[index] !== 'undefined' &&
      typeof segmentErrors[index]['endDateError'] !== 'undefined'
    ) {
      delete segmentErrors[index]
    }
    this.setState({
      dateSegments,
      mitChildError: false,
      mitChildErrorMsg: '',
      segmentErrors,
    })
  }

  updateSegmentsError = (index) => {
    const segmentErrors = this.state.segmentErrors
    if (typeof segmentErrors[index] !== 'undefined') {
      delete segmentErrors[index]
    }
    this.setState({
      segmentErrors,
    })
  }

  handleStartDateChange = (selectedDay, index) => {
    let { dateSegments } = this.state
    dateSegments[index]['startDate'] =
      moment(selectedDay).format('MMM DD, YYYY')
    const segmentErrors = this.state.segmentErrors
    if (
      typeof segmentErrors[index] !== 'undefined' &&
      typeof segmentErrors[index]['startDateError'] !== 'undefined'
    ) {
      delete segmentErrors[index]
    }
    this.setState({
      dateSegments,
      mitChildError: false,
      mitChildErrorMsg: '',
      segmentErrors,
    })
  }

  handleProgressTypeChange = (metricId) => {
    let { child_krs } = this.state;
    if(Array.isArray(child_krs)) {
      child_krs = child_krs.map((childKr) => {
        childKr.counting = getMitChildCounting(this.state.mitType, metricId, childKr.counting);
        return childKr;
      });
    }
    this.setState({
      progType: this.state.progType,
      disableProgType: true,
      dsMetric: metricId,
      child_krs: child_krs,
    })
  }

  handleStatusChange = (value,index) =>{
    const {dateSegments, child_krs} = this.state;
    if(value){
      dateSegments[index]['status'] = 3;
      child_krs[index] && (child_krs[index]['status'] = 3);
      this.setState({ dateSegments, child_krs })
    }
    else{
      dateSegments[index]['status'] = 1;
      child_krs[index] && (child_krs[index]['status'] = 1);
      this.setState({ dateSegments, child_krs })
    }
  }

  handleMitChange = (e, index) => {
    // let dateSegments = [...this.state.dateSegments]
    const {dateSegments, child_krs} = this.state;
    const pattern = /^(\.)?[0-9,-]+(\.\d{0,10})?$/
    if (e.target.name === 'intervalName') {
      dateSegments[index][e.target.name] = e.target.value;
      child_krs[index] && (child_krs[index]['name'] = e.target.value);
      this.setState({ dateSegments, child_krs })
    } else if (e.target.name === 'targetValue') {
      if (child_krs[index] && (child_krs[index]['source'] == krdetailConstants.SOURCE_WORKSTREAM)) {
        return;
      }
      if (pattern.test(e.target.value)) {
        dateSegments[index][e.target.name] = e.target.value;
        if(child_krs[index]) { // Edit flow
          child_krs[index]['target'] = e.target.value;
        }
        if (dateSegments[index]['stretchValue'] !== '') {
          if (parseFloat(e.target.value) >= parseFloat(dateSegments[index]['stretchValue'])) {
            dateSegments[index]['stretchValue'] = '';
            if(child_krs[index]) { // Edit flow
              child_krs[index]['stretch_target'] = '';
              child_krs[index]['committed_target'] = 0;
            }
          }
        }
      }

      this.setState({ dateSegments, child_krs })
    }

    if (e.target.value == '') {
      dateSegments[index][e.target.name] = e.target.value;
      child_krs[index] && e.target.name === 'targetValue' && (child_krs[index]['target'] = e.target.value);
      child_krs[index] && e.target.name === 'intervalName' && (child_krs[index]['name'] = e.target.value);
      this.setState({ dateSegments, child_krs })
    }
  }

  /**
   * Add auto-populated monthly, quarterly intervals
   * Only logic here is to ensure that the auto generated date is never over the parent goal end date
   * */
  _addAutoInterval = (type) => {
    this.setState({
      disableAddingInterval: false,
    })
    let dateSegments = []
    if (type == MIT_INTERVAL_TYPE.CUSTOM) {
      dateSegments = createDefaultMitDateSegment(this.props.goalDetails)
    } else {
      dateSegments = resolveMitDateSegments(
        this.props.item,
        this.props.goalDetails,
        type,
        this.props.goalDetails.start_date,
        this.props.goalDetails.target_date,
        this.state.quarter_start,
        this.props.mitType,
        this.props.goalDetails.filterOption,
        this.props.goalDetails.orgReportingPeriods
      )
    }
    this.setState({
      dateSegments: dateSegments,
      firstInterval: type,
    })
  }

  saveAlignArr(alignData) {
    this.setState({
      krAlingSelected: alignData,
    })
  }

  saveDependentArr(dependentData) {
    this.setState({
      krDependenciesSelected: dependentData,
    })
  }

  handleCommittedKRChange = () => {
    this.setState({
      committedKRFlag: this.state.committedKRFlag == 1 ? 0 : 1,
    })
  }

  mitPeopleCb = (measureType, MeasureEn) => {
    this.setState({ measureType: measureType, MeasureEn: MeasureEn })
  }

  measureEnCb = (param = '') => {
    if (param == false) {
      this.setState({ MeasureEn: false })
    } else {
      this.setState({ MeasureEn: !this.state.MeasureEn })
    }
  }

  kpiBtnClick = (item) => {
    this.props.clickButtonEvent(item)
    this.setState({
      progType: 1,
      childProgType: 1,
      showProgType: false,
      childPorgressEn: false,
    })
  }

  setErrors(errors) {
    this.setState({ errors })
  }

  setDateSegments(dateSegments) {
    this.setState({
      dateSegments,
    })
  }
  saveTag = (childData) => {
    this.setState({ tags: childData })
  }
  changeRadio(value) {
    const valueToSet = value
    this.setState(
      {
        selectedType: valueToSet
      }
    )
  }
  updateTags(Newtags){
    this.setState({
      selectednlplTagsName: Newtags
    })
  }
  render() {
    const { t, kpiType, addOkrData, coOwners } = this.props
    let dsProg = [
      {
        value: 1,
        name : t("Last entered value"),
      },
      {
        value: 2,
        name : t("Total of all intervals")
      }
    ];
    let childDsProg = [
      {
        value: 1,
        name : t("Last entered update"),
      },
      {
        value: 2,
        name : t("Total of all updates")
      }
    ];
    let basicIntervalArr = getIntervalOptions(
      'default',
      addOkrData.isEnabledBiweeklyKR,
      false,
      this.state.interval === krdetailConstants.INTERVAL_BIQUARTERLY
    )
    let basicDays = getWeekDaysOptions()

    let { dateSegments, progType, mitType, segmentErrors = [], child_krs } = this.state
    const totalDataSegments = Array.isArray(dateSegments) ? dateSegments.length : 0;
    const buttons = []
    buttons.push({
      id: 'person',
      label: t(`By a person`),
      iconClass: 'icon icon-number-sign-24px-bluegreen',
      buttonWrapperClass: kpiType === 'person' ? 'active' : '',
      buttonClick: this.props.clickButtonEvent,
    })
    if (
      !this.props.isEnabled('krstudio') &&
      mitType !== MIT_TYPE.ADD_UP &&
      mitType !== MIT_TYPE.SUPPORTING_QUARTER_KR &&
      progType == '1'
    ) {
      buttons.push({
        id: 'ds',
        label: t('Automated data streams'),
        iconClass: 'icon icon-data-integration-24px-bluegreen ',
        buttonWrapperClass: kpiType === 'ds' ? 'active' : '',
        buttonClick: this.kpiBtnClick,
      })
    }

    const monthDifference = Math.ceil(
      moment(this.props.goalDetails.target_date).diff(
        this.props.goalDetails.start_date,
        'months',
        true
      )
    )

    let oneInclude = false;
    if(dateSegments){
      let includeLen = dateSegments.filter((x, i)=> {
        return (child_krs[i] ? child_krs[i].status == 1 : x.status==1)
      }).length;
      if(includeLen==1){
        oneInclude = true;
      }
    }
    let setStretch = false;
    /*
    // disabling.  This is suppose to allow using the single target input for both target and stretch
    // but the logic is not populated everywhere and it is causing issues
    if ((!this.state.target && this.state.stretch) || (!this.state.target && !this.state.stretch)) {
        setStretch = true;
    }
    */
    return (
      <div>
        {(this.state.mitType || !this.props.isAnnualMit) && (
          <>
            {this.props.isAnnualMit && <div className="krBreak" aria-hidden="true" />}
            <div style={{ marginTop: '24px' }}>
              <span className={'krHeadText'}>{t('OVERALL TARGET')}</span>
            </div>
            <OverallTarget
              handleChange={this.handleChange}
              initial_data={this.state.initial_data}
              changeProgressType={this.handleProgressTypeChange}
              startValueErr={this.state.startValueErr}
              target={this.state.target}
              stretch={this.state.stretch}
              errors={this.state.errors}
              errorsObject={this.state.errors}
              {...this.props}
              mitType={this.state.mitType}
              dsMetric={this.state.dsMetric}
              committedKRFlag={this.state.committedKRFlag}
              handleCommittedKRChange={this.handleCommittedKRChange}
              MeasureEn={this.state.MeasureEn}
              measureEnCb={this.measureEnCb}
              mitPeopleCb={this.mitPeopleCb}
              measureType={this.state.measureType}
              isStretchEnabled={this.state.isStretchEnabled}
              stretchValueErr={this.state.stretchValueErr}
            />

            {/* MIT INTERVAL/MILESTONE TARGETS */}
            <div>
              <span
                className={'krHeadText'}
                data-testid="setyourtarget"
                style={{ width: 'auto', marginBlockEnd: '7px' }}
              >
                {t('SET YOUR TARGETS')}
              </span>
              {(this.state.mitType == MIT_TYPE.CUSTOM || !this.props.isAnnualMit) && (
                <span className='intervals-btns'>
                  {((!Array.isArray(this.props.item) && this.props.item.id) ||
                    !this.props.item.id ||
                    this.props.mitType == MIT_TYPE.CUSTOM) &&
                    (monthDifference <= 1 ||
                      (monthDifference > 1 && monthDifference < 5)) && (
                      <Button
                        onClick={() => this._addAutoInterval(MIT_INTERVAL_TYPE.WEEK)}
                        className={'add-extra-link cursor-pointer'}
                        data-testid="target-field"
                        aria-label='weekly-intervals'
                        variant="ghost"
                      >
                        + {t('Weekly intervals')}
                      </Button>
                    )}
                  {((!Array.isArray(this.props.item) && this.props.item.id) ||
                    !this.props.item.id ||
                    this.props.mitType == MIT_TYPE.CUSTOM) &&
                    (monthDifference >= 6 ||
                      (monthDifference > 1 && monthDifference < 5)) && (
                      <Button
                        onClick={() => this._addAutoInterval(MIT_INTERVAL_TYPE.MONTH)}
                        className={'add-extra-link cursor-pointer'}
                        data-testid="target-field"
                        variant="ghost"
                        aria-label={t('monthly-intervals')}
                      >
                        + {t('Monthly intervals')}
                      </Button>
                    )}
                  {((!Array.isArray(this.props.item) && this.props.item.id) ||
                    !this.props.item.id ||
                    this.props.mitType == MIT_TYPE.CUSTOM) &&
                    monthDifference >= 6 && (
                      <Button
                        onClick={() => this._addAutoInterval(MIT_INTERVAL_TYPE.QUARTER)}
                        className={'add-extra-link cursor-pointer'}
                        data-testid="target-field"
                        variant="ghost"
                        aria-label='quarterly-intervals'
                      >
                        + {t('Quarterly intervals')}
                      </Button>
                     )}
                </span>
              )}
            </div>
            {this.state.mitChildError && (
              <div className={'krNameError'}>{this.state.mitChildErrorMsg}</div>
            )}

            {isQuarterlyAggregationMitType(this.state.mitType) ? (
              <div style={{ display: 'flex', marginTop: '5px' }}>
                <div
                  className="metrictargettext inLineBlk"
                  style={{ width: 105 }}
                >
                  {t('Time period')}<span>*</span>
                  {/* Time period<span className="text-style-1">*</span> */}
                </div>
                <div
                  className="metrictargettext inLineBlk"
                  style={{ flexGrow: 1, paddingLeft: 5 }}
                >
                  {/* add popup */}
                  {t('Target name')}<span>*</span>
                  <span>
                    <HelpTextComp popUpContentClass="target-name-help Tooltip-Tip">
                      <div>
                        {t('Specify your target by including a')} <br />
                        {t('unique name for each quarter.')}
                        <br />
                        {'(' + t('Ex') +': '}{t('“Achieve $1m sales target”') + ')'}
                      </div>
                    </HelpTextComp>
                  </span>
                  {/* Target name<span className="text-style-1">*</span>  */}
                </div>
                <div
                  className="metrictargettext inLineBlk"
                  style={{ paddingRight: 20 }}
                >
                  {t('Target value')}<span>*</span>
                </div>
                <div
                  className="metrictargettext inLineBlk"
                  style={{ paddingRight: (totalDataSegments > 3 ? 0 : 20) , marginLeft: 11, width: 71}}
                >
                  {t('Source')}
                  {/* Time period<span className="text-style-1">*</span> */}
                </div>
              </div>
            ) : this.state.mitType == MIT_TYPE.CUSTOM || this.state.mitType == '' ? (
              <div style={{ marginTop: '5px' }}>
                <div
                  className="metrictargettext inLineBlk"
                  style={{ width: 125 }}
                >
                  {t('Start date')} <span className="text-style-1">*</span>
                </div>
                <div
                  className="metrictargettext inLineBlk"
                  style={{ width: 125, paddingLeft: 40 }}
                >
                  {t('End date')} <span className="text-style-1">*</span>
                </div>
                <div
                  className="metrictargettext inLineBlk"
                  style={{ width: 105, paddingLeft: 10 }}
                >
                  {t('Target name')} <span className="text-style-1">*</span>
                </div>
                <div
                  className="metrictargettext inLineBlk"
                  style={{ width: 125, paddingLeft: 20 }}
                >
                  {t('Target value')} <span className="text-style-1">*</span>
                </div>
              </div>
            ) : (
              <></>
            )}

            {dateSegments &&
              dateSegments.map((v, i) => {
                let pic = child_krs[i] ? child_krs[i].picture : this.props.realOwner.avatar;
                let sid = child_krs[i] && child_krs[i].source ? child_krs[i].source : 1;
                let extAppId = (child_krs[i] && child_krs[i].ext_app_id ? child_krs[i].ext_app_id : "") , qtype = (child_krs[i] ? child_krs[i].type : null) ;
                if(dateSegments[i].hasOwnProperty("source")){
                  sameSource = (dateSegments.filter(a => Object.keys(a).includes('owner')).length == 4)?((dateSegments.map(a => a.source).includes(1) || dateSegments.map(a => a.source).includes('10')) ? true : false ): sameSource;
                }
                // this is bad and mutates the dateSegments array
                v['targetValue'] = child_krs[i] ? child_krs[i].target : (v['targetValue'] ? v['targetValue'] : "");
                v['intervalName'] = child_krs[i] ? child_krs[i].name : (v['intervalName'] ? v['intervalName'] : '');
                v['status'] = child_krs[i] ? child_krs[i].status : (dateSegments[i].status) ? dateSegments[i].status : 1;
                if (this.state.isStretchEnabled) {
                  let stretchVal = child_krs[i] ? child_krs[i].stretch_target ?? child_krs[i].stretchTarget : (v['stretchValue'] ? v['stretchValue'] : "");
                  v['stretchValue'] = stretchVal;
                }
                return isQuarterlyAggregationMitType(this.state.mitType) ? (
                  <QuarterlyIntervals
                    dateSegments={dateSegments}
                    dateSegment={v}
                    targetValue={v['targetValue']}
                    intervalName={v['intervalName']}
                    quarterName={v['quarterName']}
                    targetName={v['targetName']}
                    year={v['year']}
                    status={v['status']}
                    oneInclude = {oneInclude}
                    ownerImg={pic}
                    ext_app_id={extAppId}
                    sourceId={sid}
                    qtype = {qtype}
                    handleChange={this.handleMitChange}
                    handleStatus={this.handleStatusChange}
                    handleStartDateChange={this.handleStartDateChange}
                    handleEndDateChange={this.handleEndDateChange}
                    deleteInterval={this._deleteInterval}
                    startDate={moment(v['startDate']).format('MMM DD, YYYY')}
                    endDate={v['endDate']}
                    krId={v['krId']}
                    mitIndex={i}
                    mitType={this.state.mitType}
                    isMitEdit={this.state.isMitEdit}
                    segmentError={
                      typeof segmentErrors[i] !== undefined
                        ? segmentErrors[i]
                        : {}
                    }
                    key={i}
                    saveQuarterlyKR={this.saveQuarterlyKR}
                    getProgressType={this.getProgressType}
                    counting={this.state.dsMetric}
                    child_krs={this.state.child_krs}
                    parentInitialData={this.state.initial_data}
                    {...this.props}
                    disable={(this.state.mitType == MIT_TYPE.TRACK_PROGRESSION && kpiType == 'ds') ? true :false}
                    setStretch={setStretch}
                    stretchValue={v['stretchValue']}
                    mitTypeChangeAlert ={this.state.mitTypeChangeAlert}
                    coOwners={coOwners}
                    committedKRFlag={this.state.committedKRFlag}
                  />
                ) : this.state.mitType == MIT_TYPE.CUSTOM ||
                  this.state.mitType == '' ? (
                  <MitIntervalTargets
                    dateSegments={dateSegments}
                    targetValue={v['targetValue']}
                    intervalName={v['intervalName']}
                    handleChange={this.handleMitChange}
                    handleStartDateChange={this.handleStartDateChange}
                    handleEndDateChange={this.handleEndDateChange}
                    deleteInterval={this._deleteInterval}
                    startDate={moment(v['startDate']).format('MMM DD, YYYY')}
                    endDate={v['endDate']}
                    krId={v['krId']}
                    mitIndex={i}
                    isMitEdit={this.state.isMitEdit}
                    segmentError={
                      typeof segmentErrors[i] !== undefined
                        ? segmentErrors[i]
                        : {}
                    }
                    updateSegmentsError={this.updateSegmentsError}
                    key={i}
                    {...this.props}
                    coOwners={coOwners}
                  />
                ) : (
                  <></>
                )
              })}

            {(this.state.mitType == MIT_TYPE.CUSTOM || !this.props.isAnnualMit) && (
              <Button
                className={'mit-add-interval'}
                data-testid="Advanced-options mit-add-interval"
                isDisabled={this.state.disableAddingInterval}
                onClick={this._addNewInterval}
                variant="ghost"
                aria-label={t('add-another-target')}
              >
                <i
                  className={'icon icon-outline-add_circle_outline-24px-blue '}
                />{' '}
                {t('Add another target')}
              </Button>
            )}

            {((this.state.mitType == MIT_TYPE.CUSTOM && kpiType != 'ds') ||
              !this.props.isAnnualMit) && (
              <div className="mitOverAll">
                <div className="CalculateOverAll" >
                  <span className="CalculateOverAllLabel" id="cal-overall">
                    {t('Calculate overall progress as')}
                    <HelpTextComp>
                      <div className="targetHelp displayFlex">
                        <span className="dot inLineBlk" />
                        <span className="targetHelpDec inLineBlk">
                          <strong>{t('Last entered update') + ':'} </strong>{t(`If a user entered "4" for the last update, the overall progress would also show 4.`)}
                        </span>
                      </div>
                      <div className="targetHelp displayFlex">
                        <span className="dot inLineBlk" />
                        <span className="targetHelpDec inLineBlk">
                          <strong>{t('Total of all intervals') + ':'} </strong>{t(`If a user entered "2","3", and "4" for all of their updates, the overall progress would show "9".`)}
                        </span>
                      </div>
                    </HelpTextComp>
                  </span>
                  <StyledDropdown
                    data-testid="CalculateOverDropDown"
                    id="cal-overall-dropdown"
                    aria-labelledby="cal-overall"
                    value={Number(this.state.progType)}
                    autoMenuWidth
                    onChange={(event) => {
                      this.setState({
                        progType: event.target["value"],
                      })
                    }}
                    optionTitleProp="name"
                    optionValueProp="value"
                    options={dsProg}
                    MenuProps={{
                      style: {
                        zIndex: '1500000'
                      },
                    }}
                  />
                </div>

                <div
                  className="child-kr-dropdown"
                  data-testid="child-kr-dropdown"
                >
                  {this.state.dsMetric != 4 && (
                    <div className="CalculateOverAll" >
                      <span className="CalculateOverAllLabel" id="cal-overall-child">
                        {t("Calculate each interval's progress as")}
                        <HelpTextComp popUpClass="leftAlign">
                          <div className="targetHelp displayFlex">
                            <span className="dot inLineBlk" />
                            <span className="targetHelpDec inLineBlk">
                              <strong>{t('Last entered update') + ':'} </strong>{t(`If a user entered "4" for the last update, the interval progress would also show 4.`)}
                            </span>
                          </div>
                          <div className="targetHelp displayFlex">
                            <span className="dot inLineBlk" />
                            <span className="targetHelpDec inLineBlk">
                              <strong>{t('Total of all updates') + ':'} </strong>{t(`If a user entered "2","3", and "4" for their interval updates, the interval progress would show "9".`)}
                            </span>
                          </div>
                        </HelpTextComp>
                      </span>
                    </div>
                  )}
                  {this.state.dsMetric != 4 && (
                    <StyledDropdown
                      data-testid="myAlign"
                      id="cal-overall-child-dropdown"
                      aria-labelledby="cal-overall-child"
                      value={Number(this.state.childProgType)}
                      autoMenuWidth
                      onChange={(event) => { this.setState({ childProgType: event.target["value"] }) }}
                      optionTitleProp="name"
                      optionValueProp="value"
                      options={childDsProg}
                      MenuProps={{
                        style: {
                          zIndex: '1500000'
                        },
                      }}
                    />
                  )}
                </div>
              </div>
            )}
{/* trackProgression */}
            {this.state.mitType !== MIT_TYPE.ADD_UP &&
              this.state.mitType !== MIT_TYPE.SUPPORTING_QUARTER_KR && this.state.mitType !== MIT_TYPE.AVG_RESULTS && (
                <>
                  <div
                    style={{ marginTop: '10px' }}
                    className={'wherekrDataCome'}
                  >
                    {t('How will updates be provided?')}
                  </div>
                  <ButtonsComp key="kpi-buttons" buttons={buttons} />
                  {/* <div className="krBreak" style={{ margin: "20px 0" }} />  */}
                </>
              )}

            {kpiType === 'ds' && (
              <DataStreamComp
                isMit={true}
                {...this.props}
                dateSegments={this.state.dateSegments}
                kpiType={kpiType}
                targetLowerVal={this.state.lower_limit}
                targetUpperVal={this.state.upper_limit}
                target={this.state.target}
                initial_data={this.state.initial_data}
                krAlingSelected={this.state.krAlingSelected}
                krDependenciesSelected={this.state.krDependenciesSelected}
                setErrors={this.setErrors}
                intervalType={this.state.intervalType}
                measureType={this.state.measureType}
                Exclude={this.state.Exclude}
                teamPermissionSelected={this.state.teamPermissionSelected}
                bizPermissionSelected={this.state.bizPermissionSelected}
                permissionstate={this.state.permissionstate}
                setDateSegments={this.setDateSegments}
                quarterTargetType={
                  this.props.quarterTargetType[this.state.mitType]
                }
              />
            )}
            {(

              <>
                <div
                  style={{ margin: '20px 0 5px' }}
                  className={'wherekrDataCome'}
                >
                  {t('Who will measure progress and how often') + '?'} <span className="typefacetext">*</span>
                </div>

                <div className="metrictarttargetsec">

                  <>
                    <MetricOwnerCommonModal
                      key={this.props.realOwner.id}
                      item={
                        this.state.data_provider.id
                          ? this.state.data_provider
                          : this.props.realOwner
                      }
                      updateData={this.updateDataProvider}
                      addId="mitMetrictarttargetsecId"
                      teamId={this.props.goalDetails.team_id}
                    />
                    {this.renderError('owner_validation')}
                    <div className="verticalTop krToUpdate inLineBlk">
                      {t('to update')}
                    </div>


                  <StyledDropdown
                    data-testid="myAlign"
                    id="select-interval-dropdown"
                    aria-label={t("How often to update") + '?'}
                    value={Number(this.state.intervalType)}
                    autoMenuWidth
                    onChange={(event) => {
                      this.setState({ intervalType: event.target["value"] });
                    }}
                    optionTitleProp="name"
                    optionValueProp="value"
                    options={basicIntervalArr}
                    MenuProps={{
                      style: {
                      zIndex: '1500000'
                      },
                    }}
                  />
                  {isWeeklyInterval(this.state.intervalType) && (
                    <div className="verticalTop onMetric inLineBlk">{t('On')}</div>
                  )}
                  {isWeeklyInterval(this.state.intervalType) && (
                    <StyledDropdown
                      data-testid="myAlign"
                      id="select-day-dropdown"
                      aria-label={t("Select day to update")}
                      value={Number(this.state.dayType)}
                      autoMenuWidth
                      onChange={(event) => {
                        this.setState({ dayType: event.target["value"] });
                      }}
                      optionTitleProp="name"
                      optionValueProp="value"
                      options={basicDays}
                      MenuProps={{
                        style: {
                        zIndex: '1500000'
                        },
                      }}
                    />
                  )}
                  </>

                </div>
              </>

            )}
          </>
        )}
        {this.props.customData && Object.keys(this.props.customData).length > 0 && <div className="krBreak" style={{marginBottom:"-10px"}} aria-hidden="true" />}
         {  (this.props.addOkrData.groupKRCustomFields|| this.props.groupKRCustomFields )&&
          <Customokr
            customData={this.props.customData}
            isRequiredCustomOkrFiled={this.isRequiredCustomOkrFiled}
            onCustomDataChange={(newData) => this.props.onCustomFieldsChange?.(newData)}
            customFiledRequired={true}
            renderError={this.renderError}
            isCustomSave={this.state.isCustomSave}
          />
          }
        {this.state.dsMetric != 4 && <div className="krBreak" aria-hidden="true" />}
        <AddFinancialTargetsButton objectType="kr" objectId={this.props.item?.id} ownerUserId={this.props.realOwner?.id} />
        <KrRelationshipWrapper {...this.props} metric={this.props.item} saveKr={this.saveKr}/>
        <KrAlignDependance
          {...this.props}
          saveDependentArr={this.saveDependentArr}
          saveAlignArr={this.saveAlignArr}
          krAlingArr={this.props.item.kr_aligns}
          krDependenciesArr={this.props.item.kr_dependent}
        />
        <AddKrTag
          metric={this.props.item}
          goalId={this.props.goalDetails.id}
          taghandler={this.saveTag}
          nplTags={this.state.nplTags}  selectednlplTags={this.state.selectednlplTags}
          selectednlplTagsName={this.state.selectednlplTagsName} updateTags={this.updateTags}
          tagsList={this.state.tagsList} searchText={this.props.krText}
        />
        <div className="excludeProgressArea">
          <ThemeProvider>
            <StyledCheckbox
              id='excludePro'
              isChecked={this.state.Exclude ? true : false}
              label={t(`Exclude from objective progress calculation`)}
              onChange={this.handleExcludeChange}
              ref={(node) => (this.dsExcludeProg = node)}
            />
          </ThemeProvider>
        </div>

        {!this.state.applyObjKr && (
          <div className="viewPermissionArea">
            <span>
              {t('View permissions in addition to')}{' '}
              {this.props.goalDetails.type == 1 ? ` ${t('team')} ` : ` ${t('owner')} `}
              <div
                className="metricTargetHelptext permissionHelpText"
                onMouseEnter={(event) => {
                  this.setState({ permissionHelpPopUp: true })
                }}
                onMouseLeave={(event) => {
                  this.setState({ permissionHelpPopUp: false })
                }}
              />
              {this.state.permissionHelpPopUp && (
                <div className="basic-popup">
                  {t(`You can give your whole organization permission to view your Key Result, or just your team and managers`)}
                </div>
              )}
            </span>
          </div>
        )}

        {!this.state.applyObjKr && (
          <PermissionComp
            {...this.props}
            teamPermissionData={this.teamPermissionData}
            bizPermissionData={this.bizPermissionData}
            permissionData={this.permissionData}
            hide={this.state.hide}
          />
        )}

        {this.state.confirmPopup && (
          <DeleteCommonModal
            exitDeleteModal={this.exitDeleteModal}
            deleteItems={this.saveItems}
            id=""
            title={t('Save Key Result with New Data Type')}
            deleteContentOne=""
            deleteContentSecondParam=""
            deletefirstTitle=""
            deleteContentSecond={
              t('Are you sure you want to save this key result with the new data type you selected? This will get rid of past key result data.')
            }
            buttonText={t("Save")}
          />
        )}

        {this.state.mitTypeChangeAlert && (
          <DeleteCommonModal
            controlStyle={{
              deleteModalContent: { padding: 24, minHeight: 173 },
              deleteModalTitle: { padding: 0 },
              deleteModalContentSub: {
                paddingTop: 10,
                paddingLeft: 2,
                margin: 'unset',
              },
              deleteModalFooter: { height: 0, paddingRight: 0 },
              deleteCancel: { margin: 0 },
            }}
            exitDeleteModal={this.setRightPaneValue}
            deleteItems={this.saveItems}
            id=""
            title={t("Changing MIT Type & deleting prior update")}
            deleteContentOne=""
            deleteContentSecondParam=""
            deletefirstTitle=""
            deleteContentSecond={
              t('Are you sure you want to change the MIT type of this key result') + '?'
            }
            deleteContentSecondExtra={
              t('This change will delete updates previously made to the key result data.')
            }
            deleteContentSecondNote={
              `${t('Note')}: ${t('Before making this change, you may review previous key result updates from the key result activity section.')}`
            }
            buttonText={t("Save")}
          />
        )}

        {
          this.state.intervalConfirmPopup  &&
            <RetainUpdateModal
              selectedType={this.state.selectedType}
              changeRadio={this.changeRadio}
              exitDeleteModal={this.exitDeleteModal}
              deleteItems={this.saveItems}
              titleRetain={this.state.titleRetain ? this.state.titleRetain :  t("Save key result with new data type") }
              contentRetain ={this.state.titleRetain ?  t("Are you sure you want to change the update frequency of this key result?") : t("Are you sure you want to save this key result with the new data type selected?")}
            />
        }
      </div>
    )
  }
}

export default withTranslation()(MitPeople)
